<template>
  <div>
    <Toast position="top-right" />
    <div class="card card-custom gutter-b">
      <div class="card-header" v-b-toggle.collapse-filtros>
        <div class="card-title mb-0 filtros-card-title">
          <h5 class="card-label mb-0">Filtros</h5>
          <span class="filtros-ativos-indicador" v-if="possuiFiltrosAtivos">
            {{ textoFiltrosAtivos }}
          </span>
        </div>
        <div class="card-toolbar">
          <a class="btn btn-icon btn-sm btn-light-primary mr-1">
            <i
              class="ki icon-nm"
              :class="{
                'ki-arrow-up': cardFiltros,
                'ki-arrow-down': !cardFiltros
              }"
            ></i>
          </a>

          <a
            class="btn btn-sm btn-light-primary mr-1 font-weight-bold"
            @click.stop.prevent="limparFiltros"
            v-if="possuiFiltrosAtivos"
          >
            Limpar
          </a>

          <a
            class="btn btn-sm btn-light-warning mr-1 font-weight-bold"
            :class="{ disabled: carregandoRelatorio }"
            @click.prevent="filtrarRelatorio"
          >
            Filtrar
          </a>
        </div>
      </div>

      <b-collapse id="collapse-filtros" v-model="cardFiltros">
        <div class="card-body">
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label>Conta</label>
                <div
                  class="filtro-contas-wrapper"
                  @click.capture="capturarCliqueFiltroContas"
                >
                  <pv-multiselect
                    ref="filtroContas"
                    class="form-control filtro-contas"
                    :class="{
                      'filtro-contas-com-limpar':
                        defaultsSelect.conta.length > 0
                    }"
                    optionLabel="filtro"
                    emptyFilterMessage="Nenhum resultado"
                    filterPlaceholder="Pesquisar conta, ID ou Conexa"
                    scrollHeight="320px"
                    appendTo="body"
                    :filter="true"
                    :options="sltContasOrdenadas"
                    placeholder="Todas"
                    v-model="defaultsSelect.conta"
                    @filter="aoFiltrarContas"
                    @hide="aoOcultarFiltroContas"
                    @input="obterContas"
                    @show="ajustarPainelFiltroContas"
                  >
                    <template #value="slotProps">
                      <div class="filtro-select-resumo">
                        {{ textoSelectContas(slotProps.value) }}
                      </div>
                    </template>
                    <template #option="slotProps">
                      <div class="p-multiselect-car-option filtro-conta-opcao">
                        <div class="filtro-opcao-principal">
                          <span class="filtro-opcao-nome">
                            {{ slotProps.option.text }}
                          </span>
                          <span class="filtro-opcao-meta">
                            Conta #{{ slotProps.option.contaId }}
                          </span>
                        </div>
                        <span
                          class="filtro-opcao-badge"
                          v-if="slotProps.option.contaIntegracaoId"
                        >
                          Conexa {{ slotProps.option.contaIntegracaoId }}
                        </span>
                        <span
                          class="filtro-opcao-badge filtro-opcao-badge-neutro"
                          v-else
                        >
                          Sem Conexa
                        </span>
                      </div>
                    </template>
                  </pv-multiselect>
                  <button
                    type="button"
                    class="filtro-contas-limpar"
                    aria-label="Limpar contas"
                    v-if="defaultsSelect.conta.length > 0"
                    @click.stop.prevent="limparFiltroContas"
                  >
                    <i class="pi pi-times"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label>Período</label>
                <pv-dropdown
                  class="form-control"
                  optionLabel="text"
                  emptyFilterMessage="Nenhum resultado"
                  filterPlaceholder="Pesquisar período"
                  :filter="true"
                  :options="sltPeriodos"
                  v-model="defaultsSelect.periodo"
                  @input="obterPeriodo"
                ></pv-dropdown>
              </div>
            </div>

            <div class="col-md-3" v-show="exibirDatasPeriodo">
              <div class="form-group">
                <label>Data Inicial</label>
                <b-form-datepicker
                  v-model="frmFiltrarRelatorio.dataInicial"
                  @input="reiniciarPaginacaoFiltros"
                ></b-form-datepicker>
              </div>
            </div>

            <div class="col-md-3" v-show="exibirDatasPeriodo">
              <div class="form-group">
                <label>Data Final</label>
                <b-form-datepicker
                  v-model="frmFiltrarRelatorio.dataFinal"
                  @input="reiniciarPaginacaoFiltros"
                ></b-form-datepicker>
              </div>
            </div>

            <div
              class="col-md-3"
              v-if="this.frmFiltrarRelatorio.periodo == 'MAN' && isAdmin"
            >
              <div class="form-group">
                <label>Lançamento</label>
                <pv-dropdown
                  class="form-control"
                  optionLabel="text"
                  emptyFilterMessage="Nenhum resultado"
                  filterPlaceholder="Pesquisar lançamento"
                  :filter="true"
                  :options="sltFaturamento"
                  :showClear="true"
                  placeholder="Todos"
                  v-model="defaultsSelect.faturamento"
                  @input="obterFaturamento"
                ></pv-dropdown>
              </div>
            </div>

            <div
              class="col-md-3"
              v-if="this.frmFiltrarRelatorio.periodo == 'MAN' && isAdmin"
            >
              <div class="form-group">
                <label>Faturar</label>
                <pv-dropdown
                  class="form-control"
                  optionLabel="text"
                  emptyFilterMessage="Nenhum resultado"
                  filterPlaceholder="Pesquisar opção"
                  :filter="true"
                  :options="sltFaturar"
                  :showClear="true"
                  placeholder="Todos"
                  v-model="defaultsSelect.faturar"
                  @input="obterFaturar"
                ></pv-dropdown>
              </div>
            </div>

            <div class="col-md-3" v-if="isAdmin">
              <div class="form-group">
                <label>ID Integração</label>
                <pv-dropdown
                  class="form-control filtro-integracao"
                  optionLabel="filtro"
                  emptyFilterMessage="Nenhuma integração encontrada"
                  filterPlaceholder="Pesquisar ID ou conta"
                  :filter="true"
                  :options="sltIntegracoes"
                  :showClear="true"
                  placeholder="Todas"
                  v-model="defaultsSelect.idIntegracao"
                  @input="obterIdIntegracao"
                >
                  <template #value="slotProps">
                    <div
                      class="filtro-select-resumo filtro-integracao-resumo"
                      v-if="slotProps.value"
                    >
                      <span>{{ slotProps.value.text }}</span>
                      <small>{{ slotProps.value.quantidadeContasTexto }}</small>
                    </div>
                    <div class="filtro-select-resumo" v-else>Todas</div>
                  </template>
                  <template #option="slotProps">
                    <div class="filtro-integracao-opcao">
                      <div class="filtro-opcao-principal">
                        <span class="filtro-opcao-nome">
                          {{ slotProps.option.descricaoContas }}
                        </span>
                        <span class="filtro-opcao-meta">
                          {{ slotProps.option.text }}
                        </span>
                      </div>
                      <span class="filtro-opcao-badge">
                        {{ slotProps.option.quantidadeContasTexto }}
                      </span>
                    </div>
                  </template>
                </pv-dropdown>
              </div>
            </div>
          </div>

          <b-form-group v-if="isAdmin">
            <div class="checkbox-inline">
              <label class="checkbox font-weight-normal">
                <input
                  type="checkbox"
                  name="forcarExibicaoContasSubcontas"
                  v-model="frmFiltrarRelatorio.forcarExibicaoContasSubcontas"
                  @input="reiniciarPaginacaoFiltros"
                />
                <span></span>
                Forçar exibição de contas e subcontas
              </label>

              <label class="checkbox font-weight-normal">
                <input
                  type="checkbox"
                  name="ocultarContasSemProcessamento"
                  v-model="frmFiltrarRelatorio.ocultarContasSemProcessamento"
                  @input="reiniciarPaginacaoFiltros"
                />
                <span></span>
                Ocultar contas sem processamento
              </label>

              <label class="checkbox font-weight-normal">
                <input
                  type="checkbox"
                  name="ocultarContasInativas"
                  v-model="frmFiltrarRelatorio.ocultarContasInativas"
                  @input="reiniciarPaginacaoFiltros"
                />
                <span></span>
                Ocultar contas inativas
              </label>
            </div>
          </b-form-group>

          <div
            class="contas-selecionadas-painel"
            v-if="defaultsSelect.conta.length > 0"
          >
            <div class="contas-selecionadas-cabecalho">
              <div>
                <div class="contas-selecionadas-titulo">Contas filtradas</div>
                <div class="contas-selecionadas-subtitulo">
                  {{ textoSelectContas(defaultsSelect.conta) }}
                </div>
              </div>
              <b-button
                size="sm"
                variant="light-primary"
                @click="limparFiltroContas"
              >
                Limpar contas
              </b-button>
            </div>

            <div class="contas-selecionadas-lista">
              <div
                class="contas-selecionadas-item"
                v-for="conta in contasSelecionadasFiltroOrdenadas"
                :key="conta.value"
              >
                <div class="contas-selecionadas-nome">
                  <strong>{{ conta.text }}</strong>
                  <small>{{ obterResumoContaSelecionada(conta) }}</small>
                </div>
                <button
                  type="button"
                  class="contas-selecionadas-remover"
                  :aria-label="`Remover ${conta.text}`"
                  @click="removerContaFiltro(conta)"
                >
                  &times;
                </button>
              </div>
            </div>
          </div>

          <div class="filtros-resumo" v-if="resumoFiltros.length > 0">
            <div class="filtros-resumo-titulo">Filtros selecionados</div>
            <div class="filtros-resumo-lista">
              <div
                class="filtros-resumo-item"
                v-for="filtro in resumoFiltros"
                :key="filtro.chave"
              >
                <span class="filtros-resumo-label">{{ filtro.label }}</span>
                <span class="filtros-resumo-valor">
                  {{ filtro.valor }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </b-collapse>
    </div>

    <div class="card card-custom">
      <div class="card-header">
        <div class="card-title">
          <h5 class="card-label">Resultados</h5>
        </div>

        <div class="card-toolbar">
          <b-button
            variant="success"
            class="btn-gerar-cobranca mr-2"
            @click.prevent="gerarCobrancaMultipla"
            v-if="contasSelecionadas.length > 0 && exibirSelecaoCobranca"
            >Gerar Cobrança</b-button
          >

          <div
            class="relatorio-switch visualizacao-agrupamento-toggle"
            v-if="resultadoAgrupadoDisponivel"
          >
            <button
              type="button"
              class="relatorio-switch-opcao"
              :class="{ active: !exibirAgrupado }"
              :aria-pressed="!exibirAgrupado"
              @click="
                exibirAgrupado = false;
                visualizacaoAgrupamentoAlterada = true;
              "
            >
              Tabela
            </button>
            <button
              type="button"
              class="relatorio-switch-opcao"
              :class="{ active: exibirAgrupado }"
              :aria-pressed="exibirAgrupado"
              @click="
                exibirAgrupado = true;
                visualizacaoAgrupamentoAlterada = true;
              "
            >
              Agrupado
            </button>
          </div>

          <div class="relatorio-switch visao-relatorio-toggle">
            <button
              type="button"
              class="relatorio-switch-opcao"
              :class="{ active: visaoRelatorio === 'tipo' }"
              :aria-pressed="visaoRelatorio === 'tipo'"
              @click="visaoRelatorio = 'tipo'"
            >
              Por Tipo
            </button>
            <button
              type="button"
              class="relatorio-switch-opcao"
              :class="{ active: visaoRelatorio === 'canal' }"
              :aria-pressed="visaoRelatorio === 'canal'"
              @click="visaoRelatorio = 'canal'"
            >
              Por Canal
            </button>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="resultado-resumo" v-if="linhas.length > 0">
          <div
            class="resultado-indicador"
            v-for="item in resumoResultado"
            :key="item.chave"
          >
            <span class="resultado-indicador-label">{{ item.label }}</span>
            <strong class="resultado-indicador-valor">
              {{ item.valor }}
            </strong>
            <span class="resultado-indicador-descricao">
              {{ item.descricao }}
            </span>
          </div>
        </div>

        <div class="legenda-canais" v-if="linhas.length > 0">
          <span class="legenda-item legenda-whatsapp">WhatsApp</span>
          <span class="legenda-item legenda-sms">SMS</span>
          <span class="legenda-item legenda-email">Email</span>
          <span class="legenda-item legenda-processadas">Processadas</span>
          <span class="legenda-item legenda-outro">Outros</span>
        </div>

        <div
          class="relatorio-carregando"
          v-if="carregandoRelatorio && exibirResultadoAgrupado"
        >
          <b-spinner small class="mr-2"></b-spinner>
          Atualizando relatório
        </div>

        <div class="relatorio-grupos" v-if="exibirResultadoAgrupado">
          <div
            class="relatorio-grupo-card"
            v-for="grupo in linhas"
            :key="grupo.conta"
          >
            <div class="relatorio-grupo-cabecalho">
              <div class="conta-celula conta-celula-grupo">
                <div
                  class="conta-celula-nome"
                  v-b-tooltip.noninteractive.hover
                  :title="`Código da conta: ${grupo.conta}`"
                >
                  {{ grupo.nome_conta }}
                </div>
                <small class="conta-celula-cliente">
                  {{ grupo.cliente || "Cliente não informado" }}
                </small>
                <div class="conta-celula-badges">
                  <span
                    class="conta-badge"
                    :class="
                      grupo.status_conta == 'A'
                        ? 'conta-badge-ativa'
                        : 'conta-badge-inativa'
                    "
                  >
                    {{ grupo.status_conta == "A" ? "Ativa" : "Inativa" }}
                  </span>
                  <span
                    class="conta-badge conta-badge-whatsapp"
                    v-if="grupo.whatsapp_oficial == 'S'"
                  >
                    WhatsApp oficial
                  </span>
                  <a
                    class="conta-badge conta-badge-integracao"
                    :href="obterUrlContaConexa(grupo)"
                    target="_blank"
                    rel="noopener noreferrer"
                    v-if="obterCodigoConexa(grupo)"
                  >
                    Conexa {{ obterCodigoConexa(grupo) }}
                  </a>
                  <span class="conta-badge conta-badge-sem-integracao" v-else>
                    Sem integração
                  </span>
                  <span
                    class="conta-badge"
                    :class="obterClasseBadgeFaturamento(grupo)"
                    v-if="deveExibirFaturamentoConta(grupo)"
                  >
                    {{ obterTextoBadgeFaturamento(grupo) }}
                  </span>
                </div>
                <div
                  class="conta-faturamento-info"
                  v-if="deveExibirFaturamentoConta(grupo)"
                >
                  {{ obterDetalheFaturamentoConta(grupo) }}
                </div>
              </div>
              <div class="relatorio-grupo-totais">
                <div>
                  <span>Enviado</span>
                  <strong>{{ formatarValorConsumo(grupo.enviado) }}</strong>
                </div>
                <div>
                  <span>Recebido</span>
                  <strong>{{ formatarValorConsumo(grupo.recebido) }}</strong>
                </div>
                <div>
                  <span>Total</span>
                  <strong>{{ formatarValorConsumo(grupo.total) }}</strong>
                </div>
                <button
                  type="button"
                  class="btn-acao btn-acao-cobrancas font-weight-bold relatorio-grupo-acao relatorio-grupo-acao-principal"
                  v-if="deveExibirDetalhesCobrancasConta(grupo)"
                  @click.stop="abrirDetalhesCobrancasConta(grupo)"
                >
                  Cobranças
                </button>
              </div>
            </div>

            <div
              class="relatorio-grupo-conteudo"
              :class="{
                'relatorio-grupo-conteudo-sem-contas':
                  !possuiContasAgrupadas(grupo)
              }"
            >
              <div class="relatorio-grupo-composicao">
                <div class="distribuicao-consumo">
                  <div
                    class="distribuicao-cabecalho"
                    v-if="obterDistribuicaoLinha(grupo).length > 0"
                  >
                    <span>Tipo</span>
                    <span>Env.</span>
                    <span>Rec.</span>
                    <span>Total</span>
                  </div>
                  <div
                    class="distribuicao-item"
                    :class="[
                      obterClasseDistribuicao(item),
                      { 'distribuicao-item-total': item.isTotal }
                    ]"
                    v-for="item in obterDistribuicaoLinha(grupo)"
                    :key="item.chave"
                  >
                    <div class="distribuicao-tipo">
                      <span class="distribuicao-marcador"></span>
                      <div class="distribuicao-tipo-textos">
                        <span class="distribuicao-label">
                          {{ item.descricao }}
                        </span>
                        <small>{{ obterSiglaDistribuicao(item) }}</small>
                      </div>
                    </div>
                    <span class="distribuicao-numero">
                      {{ formatarValorConsumo(item.enviado) }}
                    </span>
                    <span class="distribuicao-numero">
                      {{ formatarValorConsumo(item.recebido) }}
                    </span>
                    <div class="distribuicao-total-grupo">
                      <span class="distribuicao-total">
                        {{ formatarValorConsumo(item.total) }}
                      </span>
                    </div>
                    <span class="distribuicao-trilho">
                      <span
                        class="distribuicao-barra"
                        :style="{ width: `${item.percentual}%` }"
                      ></span>
                    </span>
                  </div>
                  <span
                    class="distribuicao-vazia"
                    v-if="obterDistribuicaoLinha(grupo).length === 0"
                  >
                    Sem consumo
                  </span>
                </div>
              </div>

              <div
                class="relatorio-grupo-contas"
                v-if="possuiContasAgrupadas(grupo)"
              >
                <div class="relatorio-grupo-contas-titulo">
                  Contas agrupadas
                </div>
                <div
                  class="relatorio-grupo-conta"
                  v-for="conta in grupo.contas_grupo"
                  :key="conta.conta"
                >
                  <div class="relatorio-grupo-conta-topo">
                    <div class="relatorio-grupo-conta-selecao">
                      <b-form-checkbox
                        v-if="contaPodeFaturar(conta)"
                        v-model="contasSelecionadas"
                        :value="conta"
                        size="lg"
                      ></b-form-checkbox>
                    </div>
                    <div class="relatorio-grupo-conta-info">
                      <strong
                        v-b-tooltip.noninteractive.hover
                        :title="`Código da conta: ${conta.conta}`"
                      >
                        {{ conta.nome_conta }}
                      </strong>
                      <small>
                        {{ conta.cliente || "Cliente não informado" }}
                      </small>
                      <div
                        class="conta-celula-badges d-flex flex-wrap align-items-center justify-content-start"
                      >
                        <span
                          class="conta-badge"
                          :class="
                            conta.status_conta == 'A'
                              ? 'conta-badge-ativa'
                              : 'conta-badge-inativa'
                          "
                        >
                          {{ conta.status_conta == "A" ? "Ativa" : "Inativa" }}
                        </span>
                        <span
                          class="conta-badge conta-badge-whatsapp"
                          v-if="conta.whatsapp_oficial == 'S'"
                        >
                          WPP
                        </span>
                        <a
                          class="conta-badge conta-badge-integracao"
                          :href="obterUrlContaConexa(conta)"
                          target="_blank"
                          rel="noopener noreferrer"
                          v-if="obterCodigoConexa(conta)"
                        >
                          Conexa {{ obterCodigoConexa(conta) }}
                        </a>
                        <span
                          class="conta-badge conta-badge-sem-integracao"
                          v-else
                        >
                          Sem integração
                        </span>
                        <span
                          class="conta-badge"
                          :class="obterClasseBadgeFaturamento(conta)"
                          v-if="deveExibirFaturamentoConta(conta)"
                        >
                          {{ obterTextoBadgeFaturamento(conta) }}
                        </span>
                      </div>
                    </div>

                    <div
                      class="relatorio-grupo-conta-resumo d-flex align-items-start justify-content-end"
                    >
                      <button
                        type="button"
                        class="btn-acao btn-acao-cobrancas font-weight-bold relatorio-grupo-acao"
                        v-if="deveExibirDetalhesCobrancasConta(conta)"
                        @click.stop="abrirDetalhesCobrancasConta(conta)"
                      >
                        Cobranças
                      </button>
                    </div>
                  </div>
                  <div
                    class="conta-faturamento-info"
                    v-if="deveExibirFaturamentoConta(conta)"
                  >
                    {{ obterDetalheFaturamentoConta(conta) }}
                  </div>
                  <div class="relatorio-grupo-conta-tipos">
                    <div class="relatorio-grupo-conta-tipos-cabecalho">
                      <span>Tipo</span>
                      <span>Env.</span>
                      <span>Rec.</span>
                      <span>Total</span>
                    </div>
                    <div
                      class="relatorio-grupo-conta-tipo"
                      :class="obterClasseDistribuicao(tipo)"
                      v-for="tipo in obterDistribuicaoResumoConta(conta)"
                      :key="tipo.chave"
                    >
                      <span class="distribuicao-marcador"></span>
                      <span class="relatorio-grupo-conta-tipo-nome">
                        {{ tipo.descricao }}
                      </span>
                      <span>{{ formatarValorConsumo(tipo.enviado) }}</span>
                      <span>{{ formatarValorConsumo(tipo.recebido) }}</span>
                      <strong>{{ formatarValorConsumo(tipo.total) }}</strong>
                    </div>
                    <div
                      class="relatorio-grupo-conta-tipos-vazio"
                      v-if="obterDistribuicaoResumoConta(conta).length === 0"
                    >
                      Sem consumo
                    </div>
                    <div class="relatorio-grupo-conta-totais">
                      <span>Total</span>
                      <span>{{ formatarValorConsumo(conta.enviado) }}</span>
                      <span>{{ formatarValorConsumo(conta.recebido) }}</span>
                      <strong>{{ formatarValorConsumo(conta.total) }}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="relatorio-tabela-container" v-else>
          <b-table
            class="relatorio-tabela"
            hover
            small
            :fields="cabecalho.cabecalho"
            :items="linhas"
            :tbody-tr-class="classeLinhaResultado"
            :busy="carregandoRelatorio"
            show-empty
          >
            <template #table-busy>
              <div class="relatorio-vazio relatorio-vazio-tabela">
                <b-spinner small class="mr-2"></b-spinner>
                <strong>Carregando relatório</strong>
              </div>
            </template>

            <template #empty>
              <div class="relatorio-vazio relatorio-vazio-tabela">
                <strong>
                  {{
                    consultaRealizada
                      ? "Nenhum registro encontrado"
                      : "Consulta não executada"
                  }}
                </strong>
                <span>
                  {{
                    consultaRealizada
                      ? "Revise os filtros e consulte novamente."
                      : "Clique em Filtrar para retornar os dados do relatório."
                  }}
                </span>
              </div>
            </template>

            <template #head(selecionar)>
              <b-form-checkbox
                v-model="todasContasSelecionadas"
                size="lg"
                @change="alternarContasSelecionadas"
              >
              </b-form-checkbox>
            </template>

            <template #cell(nome_conta)="row">
              <div
                class="conta-celula"
                :class="{
                  'conta-celula-grupo': row.item.isGrupoConta,
                  'conta-celula-subconta': row.item.agrupada
                }"
              >
                <div
                  class="conta-celula-nome"
                  v-b-tooltip.noninteractive.hover
                  :title="`Código da conta: ${row.item.conta}`"
                >
                  {{ row.value }}
                </div>
                <small class="conta-celula-cliente">
                  {{ row.item.cliente || "Cliente não informado" }}
                </small>
                <div class="conta-celula-badges">
                  <span
                    class="conta-badge"
                    :class="
                      row.item.status_conta == 'A'
                        ? 'conta-badge-ativa'
                        : 'conta-badge-inativa'
                    "
                  >
                    {{ row.item.status_conta == "A" ? "Ativa" : "Inativa" }}
                  </span>
                  <span
                    class="conta-badge conta-badge-whatsapp"
                    v-if="row.item.whatsapp_oficial == 'S'"
                  >
                    WhatsApp oficial
                  </span>
                  <a
                    class="conta-badge conta-badge-integracao"
                    :href="obterUrlContaConexa(row.item)"
                    target="_blank"
                    rel="noopener noreferrer"
                    v-if="obterCodigoConexa(row.item)"
                  >
                    Conexa {{ obterCodigoConexa(row.item) }}
                  </a>
                  <span class="conta-badge conta-badge-sem-integracao" v-else>
                    Sem integração
                  </span>
                  <span
                    class="conta-badge"
                    :class="obterClasseBadgeFaturamento(row.item)"
                    v-if="deveExibirFaturamentoConta(row.item)"
                  >
                    {{ obterTextoBadgeFaturamento(row.item) }}
                  </span>
                </div>
                <div
                  class="conta-faturamento-info"
                  v-if="deveExibirFaturamentoConta(row.item)"
                >
                  {{ obterDetalheFaturamentoConta(row.item) }}
                </div>
              </div>
            </template>

            <template #cell(selecionar)="row">
              <b-form-checkbox
                v-if="contaPodeFaturar(row.item)"
                v-model="contasSelecionadas"
                :value="row.item"
                :key="row.index"
                size="lg"
              >
              </b-form-checkbox>
            </template>

            <template #cell(enviado)="row">
              <span
                class="valor-consumo"
                :class="classeValorConsumo(row.field.key, row.value)"
              >
                {{ formatarValorConsumo(row.value) }}
              </span>
            </template>

            <template #cell(recebido)="row">
              <span
                class="valor-consumo"
                :class="classeValorConsumo(row.field.key, row.value)"
              >
                {{ formatarValorConsumo(row.value) }}
              </span>
            </template>

            <template #cell(total)="row">
              <span
                class="valor-consumo valor-consumo-total"
                :class="classeValorConsumo(row.field.key, row.value)"
              >
                {{ formatarValorConsumo(row.value) }}
              </span>
            </template>

            <template #cell(distribuicao)="row">
              <div class="distribuicao-consumo">
                <div
                  class="distribuicao-cabecalho"
                  v-if="obterDistribuicaoLinha(row.item).length > 0"
                >
                  <span>Tipo</span>
                  <span>Env.</span>
                  <span>Rec.</span>
                  <span>Total</span>
                </div>
                <div
                  class="distribuicao-item"
                  :class="[
                    obterClasseDistribuicao(item),
                    { 'distribuicao-item-total': item.isTotal }
                  ]"
                  v-for="item in obterDistribuicaoLinha(row.item)"
                  :key="item.chave"
                >
                  <div class="distribuicao-tipo">
                    <span class="distribuicao-marcador"></span>
                    <div class="distribuicao-tipo-textos">
                      <span class="distribuicao-label">
                        {{ item.descricao }}
                      </span>
                      <small>{{ obterSiglaDistribuicao(item) }}</small>
                    </div>
                  </div>
                  <span class="distribuicao-numero">
                    {{ formatarValorConsumo(item.enviado) }}
                  </span>
                  <span class="distribuicao-numero">
                    {{ formatarValorConsumo(item.recebido) }}
                  </span>
                  <div class="distribuicao-total-grupo">
                    <span class="distribuicao-total">
                      {{ formatarValorConsumo(item.total) }}
                    </span>
                  </div>
                  <span class="distribuicao-trilho">
                    <span
                      class="distribuicao-barra"
                      :style="{ width: `${item.percentual}%` }"
                    ></span>
                  </span>
                </div>
                <span
                  class="distribuicao-vazia"
                  v-if="obterDistribuicaoLinha(row.item).length === 0"
                >
                  Sem consumo
                </span>
              </div>
            </template>

            <template #cell(acoes)="row">
              <div class="acoes-tabela" v-if="!row.item.isGrupoConta">
                <b-button
                  size="sm"
                  variant="light-primary"
                  v-if="deveExibirDetalhesCobrancasConta(row.item)"
                  @click="abrirDetalhesCobrancasConta(row.item)"
                  class="btn-acao btn-acao-cobrancas font-weight-bold"
                >
                  Cobranças
                </b-button>
                <b-button
                  size="sm"
                  variant="light-primary"
                  @click="detalhes(row)"
                  class="btn-acao font-weight-bold"
                >
                  Detalhes
                </b-button>
                <b-button
                  size="sm"
                  variant="light-primary"
                  v-if="isAdmin && row.item.whatsapp_oficial == 'S'"
                  @click="mensagens(row)"
                  class="btn-acao font-weight-bold"
                >
                  Custos
                </b-button>
                <b-button
                  size="sm"
                  @click="gerarCobrancaMultipla([row.item])"
                  :class="[
                    'btn-acao btn-acao-cobranca font-weight-bolder',
                    contaJaFaturada(row.item)
                      ? 'btn-acao-cobranca-faturada'
                      : 'btn-acao-cobranca-pendente'
                  ]"
                  variant="light-success"
                  v-if="contaPodeFaturar(row.item)"
                >
                  R$
                </b-button>
              </div>
            </template>

            <template #row-details="row">
              <div class="px-10">
                <b-table
                  :fields="cabecalhoDetalhes"
                  :items="detalhesContas[row.index]"
                >
                  <template #cell(tipo)="item">
                    <span
                      class="label label-success label-pill label-inline"
                      v-if="item.value == 'Envio'"
                      >{{ item.value }}</span
                    >
                    <span
                      class="label label-primary label-pill label-inline"
                      v-else
                      >{{ item.value }}</span
                    >
                  </template>
                </b-table>
              </div>
            </template>

            <template #custom-foot v-if="linhas.length > 0">
              <b-tr class="relatorio-total-row">
                <th v-if="exibirSelecaoCobranca"></th>
                <b-th :class="['align-middle']">Total</b-th>
                <b-th :class="['align-middle', 'text-right']">
                  <span class="valor-consumo valor-consumo-rodape">
                    {{ formatarValorConsumo(obterTotalGeral("enviado")) }}
                  </span>
                </b-th>
                <b-th :class="['align-middle', 'text-right']">
                  <span class="valor-consumo valor-consumo-rodape">
                    {{ formatarValorConsumo(obterTotalGeral("recebido")) }}
                  </span>
                </b-th>
                <b-th :class="['align-middle', 'text-right']">
                  <span class="valor-consumo valor-consumo-rodape">
                    {{ formatarValorConsumo(obterTotalGeral("total")) }}
                  </span>
                </b-th>
                <b-th></b-th>
                <b-th></b-th>
              </b-tr>
            </template>
          </b-table>
        </div>

        <div class="relatorio-paginacao">
          <div class="relatorio-paginacao-resumo">
            <strong>{{ totalRegistrosPaginacao }}</strong> registros
            encontrados. Página {{ paginacao.paginaAtual }} de
            {{ paginacao.ultimaPagina }}. Totais exibidos referentes à página
            atual.
          </div>

          <div class="relatorio-paginacao-controles">
            <b-form-select
              class="relatorio-paginacao-select"
              :options="sltRegistrosPorPagina"
              v-model="frmFiltrarRelatorio.registrosPorPagina"
              :disabled="carregandoRelatorio"
              @change="alterarRegistrosPorPagina"
            ></b-form-select>

            <b-pagination
              v-model="frmFiltrarRelatorio.pagina"
              :total-rows="totalRegistrosPaginacao"
              :per-page="registrosPorPaginaAtual"
              :disabled="carregandoRelatorio || totalRegistrosPaginacao === 0"
              align="fill"
              @change="alterarPagina"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      ref="mdlProcessamentoCobranca"
      size="xl"
      title="Processamento de cobranças"
      hide-footer
      :no-close-on-backdrop="cobrancaEmProcessamento"
      :no-close-on-esc="cobrancaEmProcessamento"
      :hide-header-close="cobrancaEmProcessamento"
    >
      <div class="cobranca-modal">
        <div class="cobranca-modal-topo">
          <div>
            <label class="cobranca-modal-label">Data da venda</label>
            <b-form-input
              type="date"
              v-model="dataVendaCobranca"
              :disabled="cobrancaEmProcessamento"
            ></b-form-input>
          </div>
          <div class="cobranca-modal-resumo">
            <div>
              <span>Fila</span>
              <strong>{{ filaCobranca.length }}</strong>
            </div>
            <div>
              <span>Concluídas</span>
              <strong>{{ resumoProcessamentoCobranca.concluidas }}</strong>
            </div>
            <div>
              <span>Avisos</span>
              <strong>{{ resumoProcessamentoCobranca.avisos }}</strong>
            </div>
            <div>
              <span>Erros</span>
              <strong>{{ resumoProcessamentoCobranca.erros }}</strong>
            </div>
            <div>
              <span>Faturado</span>
              <strong>{{
                formatarValorConsumo(resumoProcessamentoCobranca.faturado)
              }}</strong>
            </div>
          </div>
        </div>

        <div class="cobranca-progresso">
          <div class="cobranca-progresso-info">
            <span>{{ textoProgressoCobranca }}</span>
            <strong>{{ percentualProcessamentoCobranca }}%</strong>
          </div>
          <div class="cobranca-progresso-trilho">
            <span
              class="cobranca-progresso-barra"
              :style="{ width: `${percentualProcessamentoCobranca}%` }"
            ></span>
          </div>
        </div>

        <div class="cobranca-fila" ref="cobrancaFila">
          <div
            class="cobranca-fila-item"
            :class="[
              `cobranca-fila-item-${item.status}`,
              { 'cobranca-fila-item-refaturamento': item.jaFaturada }
            ]"
            v-for="(item, index) in filaCobranca"
            :key="item.conta"
            :ref="'cobrancaFilaItem-' + index"
          >
            <div class="cobranca-fila-principal">
              <div>
                <strong
                  v-b-tooltip.noninteractive.hover
                  :title="`Código da conta: ${item.conta}`"
                >
                  {{ item.nome_conta }}
                </strong>
                <small>Conta {{ item.conta }}</small>
              </div>
              <span
                class="cobranca-status"
                :class="`cobranca-status-${item.status}`"
              >
                {{ obterTextoStatusCobranca(item.status) }}
              </span>
            </div>
            <div class="cobranca-fila-badges" v-if="item.jaFaturada">
              <span class="cobranca-refaturamento-badge">
                {{
                  item.faturadaPorGrupo ? "Já faturada no grupo" : "Já faturada"
                }}
              </span>
              <small
                class="cobranca-refaturamento-info"
                v-if="item.detalheFaturamento"
              >
                {{ item.detalheFaturamento }}
              </small>
            </div>
            <div class="cobranca-fila-mensagem" v-if="item.mensagem">
              {{ item.mensagem }}
            </div>
            <div
              class="cobranca-fila-aviso-agrupamento"
              v-if="item.contaPrincipalCobranca"
            >
              <strong>Faturada pela conta principal</strong>
              <span>{{ item.contaPrincipalCobranca }}</span>
            </div>
            <div
              class="cobranca-fila-contas-agrupadas"
              v-if="item.contasAgrupadasCobranca.length > 0"
            >
              <strong>Contas faturadas junto</strong>
              <span>{{ item.contasAgrupadasCobranca.join(", ") }}</span>
            </div>
            <div
              class="cobranca-fila-detalhes"
              v-if="item.resultados.length > 0"
            >
              <span>{{ item.resultados.length }} retornos</span>
              <span
                >Faturado:
                {{ formatarValorConsumo(item.quantidadeFaturada) }}</span
              >
            </div>
            <div
              class="cobranca-retornos-tabela"
              v-if="item.resumoTiposCobranca.length > 0"
            >
              <div class="cobranca-retornos-cabecalho">
                <span>Tipo</span>
                <span>Qtd.</span>
                <span>Faturado</span>
                <span>Grupo</span>
                <span>Plano</span>
              </div>
              <div
                class="cobranca-retornos-linha"
                v-for="tipo in item.resumoTiposCobranca"
                :key="tipo.chave"
              >
                <span class="cobranca-retornos-tipo">
                  {{ tipo.descricao }}
                  <small>{{ tipo.codigo }}</small>
                </span>
                <span>{{ formatarValorConsumo(tipo.quantidade) }}</span>
                <strong>{{
                  formatarValorConsumo(tipo.quantidadeFaturada)
                }}</strong>
                <span>{{ formatarValorConsumo(tipo.quantidadeGrupo) }}</span>
                <span class="cobranca-retornos-plano">{{ tipo.plano }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="cobranca-modal-acoes">
          <b-button
            variant="light-secondary"
            class="font-weight-bold"
            @click="fecharModalCobranca"
            v-if="!cobrancaEmProcessamento"
          >
            {{ cobrancaFinalizada ? "Fechar" : "Cancelar" }}
          </b-button>
          <b-button
            variant="light-danger"
            class="font-weight-bold"
            @click="cancelarProcessamentoCobranca"
            :disabled="cobrancaCancelada"
            v-if="cobrancaEmProcessamento"
          >
            {{ cobrancaCancelada ? "Cancelando..." : "Cancelar fila" }}
          </b-button>
          <b-button
            variant="success"
            class="font-weight-bold"
            @click="iniciarProcessamentoCobranca"
            :disabled="cobrancaEmProcessamento || filaCobranca.length === 0"
            v-if="!cobrancaFinalizada"
          >
            Iniciar processamento
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      ref="mdlDetalhesFaturamento"
      size="xl"
      title="Cobranças do período"
      hide-footer
    >
      <div class="faturamento-detalhe-modal">
        <div
          class="faturamento-detalhe-topo"
          v-if="detalheFaturamentoSelecionado"
        >
          <div>
            <span>Conta</span>
            <strong
              v-b-tooltip.noninteractive.hover
              :title="`Código da conta: ${detalheFaturamentoSelecionado.conta}`"
            >
              {{ detalheFaturamentoSelecionado.nome_conta }}
            </strong>
            <small>
              {{
                detalheFaturamentoSelecionado.cliente || "Cliente não informado"
              }}
            </small>
          </div>
          <div>
            <span>Status</span>
            <strong>{{
              obterTextoBadgeFaturamento(detalheFaturamentoSelecionado)
            }}</strong>
            <small>
              {{ obterDetalheFaturamentoConta(detalheFaturamentoSelecionado) }}
            </small>
          </div>
          <div>
            <span>Total faturado</span>
            <strong>
              {{
                formatarValorConsumo(
                  obterQuantidadeFaturadaConta(detalheFaturamentoSelecionado)
                )
              }}
            </strong>
            <small>
              {{
                obterFaturamentoConta(detalheFaturamentoSelecionado).mes_ano ||
                "Período não informado"
              }}
            </small>
          </div>
        </div>

        <div
          class="faturamento-detalhe-observacoes"
          v-if="
            obterObservacoesFaturamentoConta(detalheFaturamentoSelecionado)
              .length > 0
          "
        >
          <strong>Observações</strong>
          <span
            v-for="observacao in obterObservacoesFaturamentoConta(
              detalheFaturamentoSelecionado
            )"
            :key="observacao"
          >
            {{ observacao }}
          </span>
        </div>

        <div
          class="faturamento-detalhe-lista"
          v-if="
            obterCobrancasFaturamento(detalheFaturamentoSelecionado).length > 0
          "
        >
          <div
            class="faturamento-detalhe-card"
            v-for="cobranca in obterCobrancasFaturamento(
              detalheFaturamentoSelecionado
            )"
            :key="obterChaveCobrancaFaturamento(cobranca)"
          >
            <div class="faturamento-detalhe-card-topo">
              <div>
                <span>Grupo de envio</span>
                <strong>{{ obterDescricaoGrupoCobranca(cobranca) }}</strong>
              </div>
              <div>
                <span>Quantidade</span>
                <strong>
                  {{ formatarValorConsumo(obterQuantidadeCobranca(cobranca)) }}
                </strong>
              </div>
              <div>
                <span>Plano</span>
                <strong>{{ obterPlanoCobranca(cobranca) }}</strong>
              </div>
              <div>
                <span>Conexa</span>
                <div class="faturamento-detalhe-vendas">
                  <a
                    v-for="idVenda in obterIdsVendaConexaCobranca(cobranca)"
                    :key="idVenda"
                    class="faturamento-detalhe-venda-link"
                    :href="obterUrlVendaConexa(idVenda)"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Venda #{{ idVenda }}
                    <span
                      aria-hidden="true"
                      class="faturamento-detalhe-venda-icone"
                    >
                      ↗
                    </span>
                  </a>
                  <strong
                    v-if="obterIdsVendaConexaCobranca(cobranca).length === 0"
                  >
                    -
                  </strong>
                </div>
              </div>
            </div>

            <div class="faturamento-detalhe-itens">
              <div class="faturamento-detalhe-itens-cabecalho">
                <span>Tipo</span>
                <span>Env.</span>
                <span>Rec.</span>
                <span>Total</span>
                <span>Faturado</span>
              </div>
              <div
                class="faturamento-detalhe-item"
                v-for="item in obterItensCobrancaFaturamento(cobranca)"
                :key="obterChaveItemCobrancaFaturamento(cobranca, item)"
              >
                <span>
                  {{ obterDescricaoTipoCobranca(item) }}
                  <small>{{ obterCodigoTipoCobranca(item) }}</small>
                </span>
                <span>{{ formatarValorConsumo(item.enviado) }}</span>
                <span>{{ formatarValorConsumo(item.recebido) }}</span>
                <span>{{ formatarValorConsumo(item.total) }}</span>
                <strong>
                  {{
                    formatarValorConsumo(
                      item.quantidade_faturado ||
                        item.quantidade_faturado_grupo ||
                        0
                    )
                  }}
                </strong>
              </div>
            </div>
          </div>
        </div>

        <div class="relatorio-vazio" v-else>
          <strong>Sem cobranças detalhadas</strong>
          <span>
            {{
              contaFaturadaPorGrupo(detalheFaturamentoSelecionado)
                ? "As cobranças detalhadas estão na conta principal do agrupamento."
                : "Esta conta possui apenas o resumo do faturamento no período."
            }}
          </span>
        </div>
      </div>
    </b-modal>

    <modal-custo-mensagens
      :custos="custoMensagemsSelecionada"
      ref="mdlCustoMensagens"
      :textoPeriodo="textoPeriodo"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ApiService from "@/core/services/api.service";
import ModalCustoMensagens from "./ModalCustoMensagens";
import Toast from "primevue/toast";

import Swal from "sweetalert2";
import moment from "moment";

export default {
  components: { ModalCustoMensagens, Toast },
  name: "relatorio-consolidado",
  data() {
    return {
      defaultsSelect: {
        periodo: {
          value: "MA",
          text: "Mês atual"
        },
        conta: [],
        faturamento: null,
        faturar: null,
        idIntegracao: null
      },
      frmFiltrarRelatorio: {
        conta: null,
        periodo: "MA",
        dataInicial: "",
        dataFinal: "",
        faturamento: null,
        faturar: null,
        forcarExibicaoContasSubcontas: false,
        idIntegracao: null,
        ocultarContasSemProcessamento: false,
        ocultarContasInativas: false,
        pagina: 1,
        registrosPorPagina: 20
      },
      ultimosFiltrosUtilizados: {
        conta: null,
        periodo: null,
        dataInicial: "",
        dataFinal: "",
        faturamento: null,
        faturar: null,
        forcarExibicaoContasSubcontas: false,
        idIntegracao: null,
        ocultarContasSemProcessamento: false,
        ocultarContasInativas: false,
        pagina: 1,
        registrosPorPagina: 20
      },
      cabecalhos: {
        tipo: {
          camposFixos: [
            {
              key: "nome_conta",
              label: "Conta",
              sortable: false,
              tdClass: "align-middle"
            }
          ],
          cabecalho: [
            {
              key: "nome_conta",
              label: "Conta",
              sortable: false,
              tdClass: "align-middle"
            }
          ],
          topo: [],
          colspan: 0
        },
        canal: {
          camposFixos: [
            {
              key: "nome_conta",
              label: "Conta",
              sortable: false,
              tdClass: "align-middle"
            }
          ],
          cabecalho: [
            {
              key: "nome_conta",
              label: "Conta",
              sortable: false,
              tdClass: "align-middle"
            }
          ],
          topo: [],
          colspan: 0
        }
      },
      resultado: [],
      resultadoAgrupado: [],
      consultaRealizada: false,
      exibirAgrupado: false,
      visualizacaoAgrupamentoAlterada: false,
      opcoesVisualizacaoAgrupamento: [
        {
          text: "Tabela",
          value: false
        },
        {
          text: "Agrupado",
          value: true
        }
      ],
      totais: {
        tipo: {},
        canal: {}
      },
      sltContas: [],
      sltIntegracoes: [],
      sltPeriodos: [],
      sltFaturamento: [
        {
          value: "N",
          text: "Não lançado"
        },
        {
          value: "S",
          text: "Lançado"
        }
      ],
      sltFaturar: [
        {
          value: "N",
          text: "Não"
        },
        {
          value: "S",
          text: "Sim"
        }
      ],
      cardFiltros: false,
      visaoRelatorio: "tipo",
      tiposVisaoRelatorio: [
        {
          text: "Por Tipo",
          value: "tipo"
        },
        {
          text: "Por Canal",
          value: "canal"
        }
      ],
      detalhesContas: [],
      cabecalhoDetalhes: [
        {
          key: "campanha",
          label: "Campanha"
        },
        {
          key: "quantidade",
          label: "Quantidade",
          class: "text-center"
        },
        {
          key: "tipo",
          label: "Tipo",
          class: "text-center"
        }
      ],
      custoMensagemsSelecionada: {},
      todasContasSelecionadas: false,
      contasSelecionadas: [],
      dataVendaCobranca: "",
      filaCobranca: [],
      cobrancaEmProcessamento: false,
      removerListenerFecharFiltroContas: null,
      filtroContasAberto: false,
      sltContasOverlay: [],
      cobrancaCancelada: false,
      cobrancaFinalizada: false,
      detalheFaturamentoSelecionado: null,
      carregandoRelatorio: false,
      requisicaoRelatorioId: 0,
      paginacao: {
        paginaAtual: 1,
        registrosPorPagina: 20,
        totalRegistros: 0,
        ultimaPagina: 1
      },
      sltRegistrosPorPagina: [
        { value: 20, text: "20 por página" },
        { value: 50, text: "50 por página" },
        { value: 100, text: "100 por página" }
      ]
    };
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Relatório Resumido" }]);
    this.inicializar();
  },
  methods: {
    inicializar() {
      ApiService.get("relatorio/consolidado").then((response) => {
        const dados = response.data.data;

        this.sltContas = (dados.contas || []).map((conta) =>
          this.montarOpcaoConta(conta)
        );
        this.sltIntegracoes = this.montarOpcoesIntegracao(dados.contas || []);
        this.sltPeriodos = (dados.periodos || []).map((periodo) => ({
          value: periodo.codigo,
          text: periodo.descricao
        }));
        this.aplicarPeriodoPadrao();
        this.restaurarFiltrosSalvos();
        this.normalizarPeriodoAtual();
      });
    },

    obterPeriodoPadrao() {
      return (
        this.obterOpcaoSelecionada(this.sltPeriodos, "MA") ||
        this.sltPeriodos[0] || {
          value: "MA",
          text: "Mês atual"
        }
      );
    },

    aplicarPeriodoPadrao() {
      const periodoPadrao = this.obterPeriodoPadrao();

      this.defaultsSelect.periodo = periodoPadrao;
      this.frmFiltrarRelatorio.periodo = periodoPadrao.value;
    },

    normalizarPeriodoAtual() {
      const periodoAtual = this.obterOpcaoSelecionada(
        this.sltPeriodos,
        this.frmFiltrarRelatorio.periodo
      );
      const periodo = periodoAtual || this.obterPeriodoPadrao();

      this.defaultsSelect.periodo = periodo;
      this.frmFiltrarRelatorio.periodo = periodo.value;

      if (periodo.value !== "MAN") {
        this.frmFiltrarRelatorio.faturamento = null;
        this.defaultsSelect.faturamento = null;
      }

      if (periodo.value !== "personalizado") {
        this.frmFiltrarRelatorio.dataInicial = "";
        this.frmFiltrarRelatorio.dataFinal = "";
      }
    },

    obterChaveStorageFiltros() {
      return "relatorio-consolidado:filtros";
    },

    salvarFiltrosAtuais() {
      try {
        localStorage.setItem(
          this.obterChaveStorageFiltros(),
          JSON.stringify({
            filtros: this.normalizarFiltrosParaStorage(
              this.frmFiltrarRelatorio
            ),
            salvoEm: new Date().toISOString()
          })
        );
      } catch (e) {
        console.warn("Não foi possível salvar os filtros do relatório.", e);
      }
    },

    removerFiltrosSalvos() {
      try {
        localStorage.removeItem(this.obterChaveStorageFiltros());
      } catch (e) {
        console.warn("Não foi possível remover os filtros do relatório.", e);
      }
    },

    restaurarFiltrosSalvos() {
      try {
        const conteudo = localStorage.getItem(this.obterChaveStorageFiltros());

        if (!conteudo) {
          return;
        }

        const dados = JSON.parse(conteudo);
        const filtros = dados.filtros || dados;
        const filtrosNormalizados = this.normalizarFiltrosParaStorage(filtros);

        this.frmFiltrarRelatorio = {
          ...this.frmFiltrarRelatorio,
          ...filtrosNormalizados
        };
        this.defaultsSelect = {
          ...this.defaultsSelect,
          conta: this.obterOpcoesSelecionadas(
            this.sltContas,
            filtrosNormalizados.conta
          ),
          periodo:
            this.obterOpcaoSelecionada(
              this.sltPeriodos,
              filtrosNormalizados.periodo
            ) || this.defaultsSelect.periodo,
          faturamento: this.obterOpcaoSelecionada(
            this.sltFaturamento,
            filtrosNormalizados.faturamento
          ),
          faturar: this.obterOpcaoSelecionada(
            this.sltFaturar,
            filtrosNormalizados.faturar
          ),
          idIntegracao: this.obterOpcaoSelecionada(
            this.sltIntegracoes,
            filtrosNormalizados.idIntegracao
          )
        };
      } catch (e) {
        console.warn("Não foi possível restaurar os filtros do relatório.", e);
      }
    },

    normalizarFiltrosParaStorage(filtros) {
      const periodo = filtros.periodo || this.obterPeriodoPadrao().value;
      const idIntegracao = this.normalizarIdIntegracao(filtros.idIntegracao);

      return {
        conta: Array.isArray(filtros.conta) ? filtros.conta : [],
        periodo,
        dataInicial:
          periodo === "personalizado" ? filtros.dataInicial || "" : "",
        dataFinal: periodo === "personalizado" ? filtros.dataFinal || "" : "",
        faturamento: periodo === "MAN" ? filtros.faturamento || null : null,
        faturar: filtros.faturar || null,
        forcarExibicaoContasSubcontas: Boolean(
          filtros.forcarExibicaoContasSubcontas
        ),
        idIntegracao,
        ocultarContasSemProcessamento: Boolean(
          filtros.ocultarContasSemProcessamento
        ),
        ocultarContasInativas: Boolean(filtros.ocultarContasInativas),
        pagina: Number(filtros.pagina) > 0 ? Number(filtros.pagina) : 1,
        registrosPorPagina: this.normalizarRegistrosPorPagina(
          filtros.registrosPorPagina
        )
      };
    },

    obterOpcaoSelecionada(opcoes, valor) {
      if (!valor) {
        return null;
      }

      return opcoes.find((opcao) => opcao.value == valor) || null;
    },

    obterOpcoesSelecionadas(opcoes, valores) {
      if (!Array.isArray(valores) || valores.length === 0) {
        return [];
      }

      return valores.map((valor) => {
        const opcao = opcoes.find((item) => item.value == valor);

        return opcao || { value: valor, text: `Conta ${valor}` };
      });
    },

    obterContaIntegracaoId(conta) {
      const valor =
        conta.conta_integracao_id ||
        conta.integracao_id ||
        conta.codigo_integracao ||
        conta.idIntegracao;

      return valor || null;
    },

    montarOpcaoConta(conta) {
      const contaId = conta.id;
      const nome = conta.login || conta.nome || `Conta ${contaId}`;
      const contaIntegracaoId = this.obterContaIntegracaoId(conta);
      const resumoFiltro = contaIntegracaoId
        ? `Conta #${contaId} · Conexa ${contaIntegracaoId}`
        : `Conta #${contaId} · Sem Conexa`;

      const termosBusca = [nome, contaId];

      if (contaIntegracaoId) {
        termosBusca.push(contaIntegracaoId, `conexa ${contaIntegracaoId}`);
      }

      return {
        value: contaId,
        text: nome,
        filtro: termosBusca.filter(Boolean).join(" "),
        contaId,
        contaIntegracaoId,
        resumoFiltro
      };
    },

    montarOpcoesIntegracao(contas) {
      const integracoes = contas.reduce((acumulador, conta) => {
        const contaIntegracaoId = this.obterContaIntegracaoId(conta);

        if (!contaIntegracaoId) {
          return acumulador;
        }

        const chave = String(contaIntegracaoId);
        const contaOpcao = this.montarOpcaoConta(conta);

        if (!acumulador[chave]) {
          acumulador[chave] = {
            value: contaIntegracaoId,
            text: `Conexa ${contaIntegracaoId}`,
            contas: []
          };
        }

        acumulador[chave].contas.push(contaOpcao);

        return acumulador;
      }, {});

      return Object.values(integracoes)
        .map((integracao) => {
          const contasOrdenadas = integracao.contas.sort((a, b) =>
            String(a.text).localeCompare(String(b.text))
          );
          const nomes = contasOrdenadas.map((conta) => conta.text);
          const descricaoContas = this.obterDescricaoContasIntegracao(nomes);
          const quantidadeContasTexto =
            contasOrdenadas.length === 1
              ? "1 conta"
              : `${contasOrdenadas.length} contas`;

          return {
            ...integracao,
            contas: contasOrdenadas,
            quantidadeContasTexto,
            descricaoContas,
            filtro: [
              integracao.value,
              `conexa ${integracao.value}`,
              ...contasOrdenadas.map((conta) => conta.text),
              ...contasOrdenadas.map((conta) => conta.contaId)
            ]
              .filter(Boolean)
              .join(" ")
          };
        })
        .sort((a, b) =>
          String(a.value).localeCompare(String(b.value), undefined, {
            numeric: true
          })
        );
    },

    obterDescricaoContasIntegracao(nomes) {
      const primeirasContas = nomes.slice(0, 3).join(", ");
      const restantes = nomes.length - 3;

      if (restantes > 0) {
        return `${primeirasContas} e mais ${restantes}`;
      }

      return primeirasContas;
    },

    filtrarRelatorio(e = null) {
      if (e) e.stopPropagation();

      this.obterPaginaRelatorio(1, true, true);
    },

    obterPaginaRelatorio(
      pagina = this.frmFiltrarRelatorio.pagina,
      fecharFiltros = false,
      limparSelecao = false
    ) {
      if (this.carregandoRelatorio) {
        return Promise.resolve();
      }

      const payload = this.montarPayloadRelatorio(pagina);

      if (!payload) {
        return Promise.resolve();
      }

      const requisicaoAtual = this.requisicaoRelatorioId + 1;
      this.requisicaoRelatorioId = requisicaoAtual;
      this.carregandoRelatorio = true;

      if (limparSelecao) {
        this.contasSelecionadas = [];
      }

      return ApiService.post("relatorio/consolidado/filtrar", payload)
        .then((response) => {
          if (requisicaoAtual !== this.requisicaoRelatorioId) {
            return;
          }

          this.montarRelatorio(response.data.data);
          this.ultimosFiltrosUtilizados = {
            ...payload,
            pagina: this.paginacao.paginaAtual,
            registrosPorPagina: this.paginacao.registrosPorPagina
          };
          this.salvarFiltrosAtuais();

          if (fecharFiltros) {
            this.cardFiltros = false;
          }
        })
        .catch((error) => {
          this.tratarErroFiltroRelatorio(error);
        })
        .finally(() => {
          if (requisicaoAtual === this.requisicaoRelatorioId) {
            this.carregandoRelatorio = false;
          }
        });
    },

    aplicarPaginacao(paginacao = {}) {
      const paginaAtual = Number(paginacao.pagina_atual) || 1;
      const registrosPorPagina = this.normalizarRegistrosPorPagina(
        paginacao.registros_por_pagina
      );
      const totalRegistros = Number(paginacao.total_registros) || 0;
      const ultimaPagina = Number(paginacao.ultima_pagina) || 1;

      this.paginacao = {
        paginaAtual,
        registrosPorPagina,
        totalRegistros,
        ultimaPagina
      };
      this.frmFiltrarRelatorio.pagina = paginaAtual;
      this.frmFiltrarRelatorio.registrosPorPagina = registrosPorPagina;
    },

    montarPayloadRelatorio(pagina = this.frmFiltrarRelatorio.pagina) {
      if (!this.validarFiltrosRelatorio()) {
        return null;
      }

      const periodo = this.frmFiltrarRelatorio.periodo || null;
      const registrosPorPagina = this.normalizarRegistrosPorPagina(
        this.frmFiltrarRelatorio.registrosPorPagina
      );
      const idIntegracao = this.normalizarIdIntegracao(
        this.frmFiltrarRelatorio.idIntegracao
      );
      const payload = {
        conta: Array.isArray(this.frmFiltrarRelatorio.conta)
          ? this.frmFiltrarRelatorio.conta
          : [],
        periodo,
        faturamento:
          periodo === "MAN"
            ? this.frmFiltrarRelatorio.faturamento || null
            : null,
        faturar: this.frmFiltrarRelatorio.faturar || null,
        forcarExibicaoContasSubcontas: Boolean(
          this.frmFiltrarRelatorio.forcarExibicaoContasSubcontas
        ),
        idIntegracao,
        ocultarContasSemProcessamento: Boolean(
          this.frmFiltrarRelatorio.ocultarContasSemProcessamento
        ),
        ocultarContasInativas: Boolean(
          this.frmFiltrarRelatorio.ocultarContasInativas
        ),
        pagina: Number(pagina) > 0 ? Number(pagina) : 1,
        registrosPorPagina
      };

      if (periodo === "personalizado") {
        payload.dataInicial = this.frmFiltrarRelatorio.dataInicial || "";
        payload.dataFinal = this.frmFiltrarRelatorio.dataFinal || "";
      }

      return payload;
    },

    validarFiltrosRelatorio() {
      if (
        this.frmFiltrarRelatorio.conta &&
        this.frmFiltrarRelatorio.conta.length > 50
      ) {
        Swal.fire({
          title: "MENSAGEM",
          text: "O relatório permite consultar até 50 contas por filtro.",
          icon: "warning",
          heightAuto: false
        });
        return false;
      }

      if (this.frmFiltrarRelatorio.periodo === "personalizado") {
        if (
          !this.frmFiltrarRelatorio.dataInicial ||
          !this.frmFiltrarRelatorio.dataFinal
        ) {
          Swal.fire({
            title: "MENSAGEM",
            text: "Informe data inicial e data final para consultar um período personalizado.",
            icon: "warning",
            heightAuto: false
          });
          return false;
        }
      }

      return true;
    },

    normalizarRegistrosPorPagina(registrosPorPagina) {
      const valor = Number(registrosPorPagina);

      return [20, 50, 100].includes(valor) ? valor : 20;
    },

    normalizarIdIntegracao(idIntegracao) {
      const valor = Number(idIntegracao);

      return Number.isInteger(valor) && valor > 0 ? valor : null;
    },

    tratarErroFiltroRelatorio(error) {
      const status = error && error.response && error.response.status;
      const data = error && error.response && error.response.data;
      const mensagem =
        (data && (data.message || data.mensagem)) ||
        "Não foi possível consultar o relatório.";

      if (status === 422) {
        Swal.fire({
          title: "Validação",
          text: mensagem,
          icon: "warning",
          heightAuto: false
        });
        return;
      }

      if (status === 403) {
        Swal.fire({
          title: "Permissão",
          text: "Você não tem permissão para consultar este relatório.",
          icon: "warning",
          heightAuto: false
        });
        return;
      }

      Swal.fire({
        title: "Erro",
        text: mensagem,
        icon: "error",
        heightAuto: false
      });
    },

    montarRelatorio(dados) {
      const resultado = dados.resultado || [];
      const totais = dados.totais || {};
      this.aplicarPaginacao(dados.paginacao || {});
      const consumosTotais = this.obterConsumosTotais(resultado, totais);
      const totaisRelatorio = this.obterTotaisRelatorio(resultado, totais);
      const tiposEnvio = this.obterTiposEnvio(resultado, consumosTotais);
      const canais = this.obterCanais(tiposEnvio);

      this.cabecalhos = {
        tipo: this.montarCabecalho(
          this.obterGruposComTotal(tiposEnvio),
          "tipo"
        ),
        canal: this.montarCabecalho(this.obterGruposComTotal(canais), "canal")
      };
      const linhas = resultado.map((item) =>
        this.montarLinhaRelatorio(item, tiposEnvio, canais)
      );

      const resultadoAgrupado = this.deveAgruparResultado(linhas)
        ? this.agruparLinhasPorContaPrincipal(linhas)
        : linhas;

      this.resultado = linhas;
      this.resultadoAgrupado = resultadoAgrupado;
      this.consultaRealizada = true;

      this.totais = {
        tipo: this.montarTotaisPorTipo(
          totaisRelatorio,
          consumosTotais,
          tiposEnvio
        ),
        canal: this.montarTotaisPorCanal(
          totaisRelatorio,
          consumosTotais,
          canais
        )
      };
    },

    deveAgruparResultado(linhas) {
      return (
        this.frmFiltrarRelatorio.forcarExibicaoContasSubcontas ||
        linhas.some(
          (linha) =>
            linha.conta_principal_id && linha.agrupar_faturamento == "S"
        )
      );
    },

    obterConsumosTotais(resultado, totais) {
      if (totais.por_tipo_envio) {
        return totais.por_tipo_envio;
      }

      return this.agruparConsumosPorTipo(
        resultado.reduce(
          (itens, item) => itens.concat(item.consumo_por_tipo_envio || []),
          []
        )
      );
    },

    obterTotaisRelatorio(resultado, totais) {
      if (
        totais.enviado !== undefined ||
        totais.recebido !== undefined ||
        totais.total !== undefined
      ) {
        return totais;
      }

      const totaisTipo = totais.tipo || {};

      return {
        enviado: this.obterPrimeiroNumero([
          totaisTipo.total_total_envios,
          this.somarCampoResultado(resultado, "enviado", "total_envios")
        ]),
        recebido: this.obterPrimeiroNumero([
          totaisTipo.total_total_respostas,
          this.somarCampoResultado(resultado, "recebido", "total_respostas")
        ]),
        total: this.obterPrimeiroNumero([
          totaisTipo.total_total_geral,
          this.somarCampoResultado(resultado, "total", "total_geral")
        ])
      };
    },

    obterPrimeiroNumero(valores) {
      const valor = valores.find(
        (item) => item !== undefined && item !== null && item !== ""
      );

      return Number(valor) || 0;
    },

    somarCampoResultado(resultado, campo, campoLegado) {
      return resultado.reduce((total, item) => {
        const totais = item.totais || {};

        return (
          total +
          this.obterPrimeiroNumero([
            totais[campo],
            campoLegado ? item[campoLegado] : undefined,
            item[campo]
          ])
        );
      }, 0);
    },

    agruparConsumosPorTipo(consumos) {
      const agrupados = consumos.reduce((acumulador, consumo) => {
        const tipoEnvio = consumo.tipo_envio || {};
        const chave = tipoEnvio.tipo_envio_id;

        if (!chave) {
          return acumulador;
        }

        if (!acumulador[chave]) {
          acumulador[chave] = {
            tipo_envio: tipoEnvio,
            enviado: 0,
            recebido: 0,
            total: 0
          };
        }

        acumulador[chave].enviado += Number(consumo.enviado) || 0;
        acumulador[chave].recebido += Number(consumo.recebido) || 0;
        acumulador[chave].total += Number(consumo.total) || 0;

        return acumulador;
      }, {});

      return Object.values(agrupados);
    },

    obterGruposComTotal(grupos) {
      return [{ chave: "GERAL", descricao: "Total" }].concat(grupos);
    },

    possuiContasAgrupadas(grupo) {
      return grupo.contas_grupo && grupo.contas_grupo.length > 0;
    },

    obterCodigoConexa(conta) {
      return conta && conta.codigo_integracao;
    },

    obterUrlContaConexa(conta) {
      return `https://w3.conexa.app/index.php?r=vendaRecorrente/gerenciarContratos&idCliente=${this.obterCodigoConexa(
        conta
      )}`;
    },

    agruparLinhasPorContaPrincipal(linhas) {
      const grupos = linhas.reduce((acumulador, linha) => {
        const chaveGrupo = linha.conta_principal_id || linha.conta;

        if (!acumulador[chaveGrupo]) {
          acumulador[chaveGrupo] = [];
        }

        acumulador[chaveGrupo].push(linha);

        return acumulador;
      }, {});

      return Object.values(grupos).reduce((linhasAgrupadas, grupo) => {
        const possuiSubconta = grupo.some((linha) => linha.conta_principal_id);

        if (!possuiSubconta || grupo.length === 1) {
          return linhasAgrupadas.concat(grupo);
        }

        const principal =
          grupo.find((linha) => !linha.conta_principal_id) || grupo[0];
        const linhasOrdenadas = grupo.slice().sort((a, b) => {
          if (!a.conta_principal_id && b.conta_principal_id) {
            return -1;
          }

          if (a.conta_principal_id && !b.conta_principal_id) {
            return 1;
          }

          return String(a.nome_conta).localeCompare(String(b.nome_conta));
        });

        return linhasAgrupadas.concat(
          this.montarLinhaGrupoConta(principal, linhasOrdenadas)
        );
      }, []);
    },

    montarLinhaGrupoConta(principal, linhas) {
      const totais = linhas.reduce(
        (acumulador, linha) => {
          acumulador.enviado += Number(linha.enviado) || 0;
          acumulador.recebido += Number(linha.recebido) || 0;
          acumulador.total += Number(linha.total) || 0;

          return acumulador;
        },
        { enviado: 0, recebido: 0, total: 0 }
      );

      return {
        conta: principal.conta,
        conta_principal_id: principal.conta_principal_id,
        nome_conta: principal.nome_conta,
        cliente: `${linhas.length} contas no grupo`,
        status_conta: principal.status_conta,
        whatsapp_oficial: principal.whatsapp_oficial,
        existe_integracao: principal.existe_integracao,
        codigo_integracao: principal.codigo_integracao,
        conta_integracao_id: principal.conta_integracao_id,
        origem_integracao: principal.origem_integracao,
        conta_faturamento: principal.conta_faturamento,
        faturado: principal.faturado,
        plano_faturado: principal.plano_faturado,
        conta_faturada_id: principal.conta_faturada_id,
        faturamento_mes_ano: principal.faturamento_mes_ano,
        faturamento_quantidade_total: principal.faturamento_quantidade_total,
        faturamento_data: principal.faturamento_data,
        faturar: principal.faturar,
        habilitada_faturamento: principal.habilitada_faturamento,
        habilitado_faturamento: principal.habilitado_faturamento,
        faturamento_habilitado: principal.faturamento_habilitado,
        conta_habilitada_faturamento: principal.conta_habilitada_faturamento,
        habilitada_para_faturamento: principal.habilitada_para_faturamento,
        pode_faturar: principal.pode_faturar,
        tipo_linha: "grupo",
        isGrupoConta: true,
        contas_grupo: linhas.map((linha) => ({
          conta: linha.conta,
          nome_conta: linha.nome_conta,
          cliente: linha.cliente,
          status_conta: linha.status_conta,
          whatsapp_oficial: linha.whatsapp_oficial,
          existe_integracao: linha.existe_integracao,
          codigo_integracao: linha.codigo_integracao,
          conta_integracao_id: linha.conta_integracao_id,
          origem_integracao: linha.origem_integracao,
          conta_faturamento: linha.conta_faturamento,
          conta_faturada_id: linha.conta_faturada_id,
          faturamento_mes_ano: linha.faturamento_mes_ano,
          faturamento_quantidade_total: linha.faturamento_quantidade_total,
          faturamento_data: linha.faturamento_data,
          habilitada_faturamento: linha.habilitada_faturamento,
          habilitado_faturamento: linha.habilitado_faturamento,
          faturamento_habilitado: linha.faturamento_habilitado,
          conta_habilitada_faturamento: linha.conta_habilitada_faturamento,
          habilitada_para_faturamento: linha.habilitada_para_faturamento,
          pode_faturar: linha.pode_faturar,
          faturado: linha.faturado,
          plano_faturado: linha.plano_faturado,
          faturar: linha.faturar,
          enviado: linha.enviado,
          recebido: linha.recebido,
          total: linha.total,
          distribuicao_tipo: linha.distribuicao_tipo,
          distribuicao_canal: linha.distribuicao_canal
        })),
        enviado: totais.enviado,
        recebido: totais.recebido,
        total: totais.total,
        distribuicao_tipo: this.agruparDistribuicoes(
          linhas.reduce(
            (itens, linha) => itens.concat(linha.distribuicao_tipo || []),
            []
          ),
          totais.total
        ),
        distribuicao_canal: this.agruparDistribuicoes(
          linhas.reduce(
            (itens, linha) => itens.concat(linha.distribuicao_canal || []),
            []
          ),
          totais.total
        )
      };
    },

    agruparDistribuicoes(distribuicoes, totalGeral) {
      const agrupadas = distribuicoes.reduce((acumulador, item) => {
        const chave = item.chave;

        if (!acumulador[chave]) {
          acumulador[chave] = {
            chave,
            canal: item.canal,
            codigo: item.codigo,
            descricao: item.descricao,
            enviado: 0,
            recebido: 0,
            total: 0,
            percentual: 0
          };
        }

        acumulador[chave].enviado += Number(item.enviado) || 0;
        acumulador[chave].recebido += Number(item.recebido) || 0;
        acumulador[chave].total += Number(item.total) || 0;

        return acumulador;
      }, {});

      return Object.values(agrupadas)
        .map((item) => ({
          ...item,
          percentual: this.calcularPercentual(item.total, totalGeral)
        }))
        .filter((item) => item.total > 0)
        .sort((a, b) => b.total - a.total);
    },

    obterTiposEnvio(resultado, consumosTotais) {
      const consumos = consumosTotais.concat(
        resultado.reduce(
          (itens, item) => itens.concat(item.consumo_por_tipo_envio || []),
          []
        )
      );

      return consumos.reduce((tipos, consumo) => {
        const tipoEnvio = consumo.tipo_envio || {};
        const chave = tipoEnvio.tipo_envio_id;

        if (!chave || tipos.some((tipo) => tipo.chave == chave)) {
          return tipos;
        }

        tipos.push({
          chave,
          descricao: tipoEnvio.tev_descricao,
          siglaCanal: tipoEnvio.mtp_sigla,
          canalCodigo: this.obterCanalConsumo(consumo).chave,
          canalDescricao: this.obterCanalConsumo(consumo).descricao
        });

        return tipos;
      }, []);
    },

    obterCanais(tiposEnvio) {
      return tiposEnvio.reduce((canais, tipoEnvio) => {
        const chave = tipoEnvio.canalCodigo || tipoEnvio.siglaCanal || "OUTRO";

        if (!canais.some((canal) => canal.chave == chave)) {
          canais.push({
            chave,
            descricao:
              tipoEnvio.canalDescricao || this.obterDescricaoCanal(chave)
          });
        }

        return canais;
      }, []);
    },

    obterCanalConsumo(consumo) {
      const tipoEnvio = (consumo && consumo.tipo_envio) || {};
      const canal = (consumo && consumo.canal) || {};
      const chave = canal.codigo || tipoEnvio.mtp_sigla || "OUTRO";

      return {
        chave,
        descricao: canal.descricao || this.obterDescricaoCanal(chave)
      };
    },

    obterDescricaoCanal(sigla) {
      const canais = {
        E: "Email",
        P: "Processadas",
        S: "SMS",
        W: "WhatsApp"
      };

      return canais[sigla] || sigla;
    },

    montarCabecalho() {
      const camposFixos = [
        {
          key: "nome_conta",
          label: "Conta",
          sortable: true,
          tdClass: "align-middle"
        }
      ];

      return {
        camposFixos,
        cabecalho: camposFixos.concat([
          {
            key: "enviado",
            label: "Enviado",
            sortable: true,
            class: "text-right coluna-consumo",
            tdClass: "text-right align-middle coluna-consumo",
            thStyle: { width: "84px" }
          },
          {
            key: "recebido",
            label: "Recebido",
            sortable: true,
            class: "text-right coluna-consumo",
            tdClass: "text-right align-middle coluna-consumo",
            thStyle: { width: "96px" }
          },
          {
            key: "total",
            label: "Total",
            sortable: true,
            class: "text-right coluna-consumo",
            tdClass: "text-right align-middle coluna-consumo",
            thStyle: { width: "88px" }
          },
          {
            key: "distribuicao",
            label: "Composição",
            sortable: false,
            class: "coluna-composicao",
            tdClass: "align-middle coluna-composicao",
            thStyle: { width: "38%" }
          }
        ]),
        topo: [],
        colspan: 0
      };
    },

    obterColunasConsumo(grupo, prefixo) {
      return [
        {
          key: this.obterChaveConsumo(prefixo, grupo.chave, "enviado"),
          label: "Enviado",
          class: "text-center",
          tdClass: "text-center align-middle"
        },
        {
          key: this.obterChaveConsumo(prefixo, grupo.chave, "recebido"),
          label: "Recebido",
          class: "text-center",
          tdClass: "text-center align-middle"
        },
        {
          key: this.obterChaveConsumo(prefixo, grupo.chave, "total"),
          label: "Total",
          class: "text-center",
          tdClass: "text-center align-middle"
        }
      ];
    },

    obterChaveConsumo(prefixo, chave, campo) {
      const chaveFormatada = String(chave).replace(/[^a-zA-Z0-9]/g, "_");

      return `${prefixo}_${chaveFormatada}_${campo}`;
    },

    montarLinhaRelatorio(item, tiposEnvio, canais) {
      const conta =
        item.conta && typeof item.conta === "object" ? item.conta : {};
      const contaIntegracao = item.conta_integracao || {};
      const contaFaturamento = item.conta_faturamento || {};
      const totais = item.totais || {};
      const contaId = conta.id || item.conta;
      const contaPrincipalId =
        conta.conta_principal_id || item.conta_principal_id;
      const enviado = this.obterPrimeiroNumero([
        totais.enviado,
        item.total_envios,
        item.enviado
      ]);
      const recebido = this.obterPrimeiroNumero([
        totais.recebido,
        item.total_respostas,
        item.recebido
      ]);
      const total = this.obterPrimeiroNumero([
        totais.total,
        item.total_geral,
        item.total
      ]);
      const linha = {
        conta: contaId,
        conta_principal_id: contaPrincipalId,
        nome_conta: conta.nome || item.nome_conta,
        cliente: item.cliente,
        status_conta: conta.status || item.status,
        whatsapp_oficial:
          conta.whatsapp_oficial || item.whatsapp_oficial || "N",
        existe_integracao:
          item.existe_integracao || (contaIntegracao.integracao_id ? "S" : "N"),
        codigo_integracao:
          item.codigo_integracao || contaIntegracao.integracao_id,
        plano: item.plano || contaIntegracao.plano_id,
        solicitante_id: item.solicitante_id || contaIntegracao.solicitante_id,
        conta_integracao_id: contaIntegracao.conta_id,
        origem_integracao: contaIntegracao.origem,
        conta_faturamento: contaFaturamento,
        status_resultado: item.status || null,
        mensagem_resultado: item.message || item.mensagem || null,
        erro_resultado: item.error || item.erro || null,
        resultado_original: item,
        faturado:
          item.faturado !== undefined
            ? item.faturado
            : contaFaturamento.faturado,
        plano_faturado: item.plano_faturado || contaFaturamento.plano_faturado,
        conta_faturada_id:
          item.conta_faturada_id || contaFaturamento.conta_faturada_id,
        faturamento_mes_ano: contaFaturamento.mes_ano,
        faturamento_quantidade_total: contaFaturamento.quantidade_total,
        faturamento_data: contaFaturamento.data_faturamento,
        habilitada_faturamento: item.habilitada_faturamento,
        habilitado_faturamento: item.habilitado_faturamento,
        faturamento_habilitado: item.faturamento_habilitado,
        conta_habilitada_faturamento: item.conta_habilitada_faturamento,
        habilitada_para_faturamento: item.habilitada_para_faturamento,
        pode_faturar: item.pode_faturar,
        faturar: item.faturar || (contaIntegracao.integracao_id ? "S" : "N"),
        agrupar_faturamento:
          item.agrupar_faturamento || contaIntegracao.agrupar_faturamento,
        tipo_linha: contaPrincipalId ? "subconta" : "conta",
        isGrupoConta: false,
        enviado,
        recebido,
        total,
        distribuicao_tipo: [],
        distribuicao_canal: []
      };

      this.inicializarValoresConsumo(
        linha,
        this.obterGruposComTotal(tiposEnvio),
        "tipo"
      );
      this.inicializarValoresConsumo(
        linha,
        this.obterGruposComTotal(canais),
        "canal"
      );
      this.somarConsumo(linha, "tipo", "GERAL", {
        enviado: linha.enviado,
        recebido: linha.recebido,
        total: linha.total
      });
      this.somarConsumo(linha, "canal", "GERAL", {
        enviado: linha.enviado,
        recebido: linha.recebido,
        total: linha.total
      });

      (item.consumo_por_tipo_envio || []).forEach((consumo) => {
        const tipoEnvio = consumo.tipo_envio || {};
        const canal = this.obterCanalConsumo(consumo).chave;

        this.somarConsumo(linha, "tipo", tipoEnvio.tipo_envio_id, consumo);
        this.somarConsumo(linha, "canal", canal, consumo);
      });

      linha.distribuicao_tipo = this.montarDistribuicaoPorTipo(
        item.consumo_por_tipo_envio || [],
        linha.total
      );
      linha.distribuicao_canal = this.montarDistribuicaoPorCanal(
        item.consumo_por_tipo_envio || [],
        linha.total
      );

      return linha;
    },

    montarDistribuicaoPorTipo(consumos, totalGeral) {
      return consumos
        .map((consumo) => {
          const tipoEnvio = consumo.tipo_envio || {};
          const total = Number(consumo.total) || 0;

          return {
            chave: tipoEnvio.tipo_envio_id,
            canal: this.obterCanalConsumo(consumo).chave,
            codigo: tipoEnvio.tev_codigo,
            descricao: tipoEnvio.tev_descricao || "Não informado",
            enviado: Number(consumo.enviado) || 0,
            recebido: Number(consumo.recebido) || 0,
            total,
            percentual: this.calcularPercentual(total, totalGeral)
          };
        })
        .filter((item) => item.total > 0)
        .sort((a, b) => b.total - a.total);
    },

    montarDistribuicaoPorCanal(consumos, totalGeral) {
      const canais = consumos.reduce((acumulador, consumo) => {
        const canal = this.obterCanalConsumo(consumo);
        const chave = canal.chave;

        if (!acumulador[chave]) {
          acumulador[chave] = {
            chave,
            canal: chave,
            codigo: chave,
            descricao: canal.descricao,
            enviado: 0,
            recebido: 0,
            total: 0,
            percentual: 0
          };
        }

        acumulador[chave].enviado += Number(consumo.enviado) || 0;
        acumulador[chave].recebido += Number(consumo.recebido) || 0;
        acumulador[chave].total += Number(consumo.total) || 0;

        return acumulador;
      }, {});

      return Object.values(canais)
        .map((canal) => ({
          ...canal,
          percentual: this.calcularPercentual(canal.total, totalGeral)
        }))
        .filter((item) => item.total > 0)
        .sort((a, b) => b.total - a.total);
    },

    calcularPercentual(valor, total) {
      if (!total) {
        return 0;
      }

      return Math.max(Math.round((valor / total) * 100), 2);
    },

    obterDistribuicaoCompleta(linha) {
      const chave =
        this.visaoRelatorio == "tipo"
          ? "distribuicao_tipo"
          : "distribuicao_canal";

      return linha[chave] || [];
    },

    obterDistribuicaoLinha(linha) {
      const distribuicao = this.obterDistribuicaoCompleta(linha);

      if (distribuicao.length === 0) {
        return [];
      }

      return distribuicao.concat({
        chave: "TOTAL",
        canal: "TOTAL",
        codigo: "TOTAL",
        descricao: "Total",
        enviado: Number(linha.enviado) || 0,
        recebido: Number(linha.recebido) || 0,
        total: Number(linha.total) || 0,
        percentual: 100,
        isTotal: true
      });
    },

    obterDistribuicaoResumoConta(conta) {
      return this.obterDistribuicaoCompleta(conta);
    },

    obterClasseDistribuicao(item) {
      if (item.isTotal) {
        return "distribuicao-total-linha";
      }

      const canal = item.canal || item.chave;
      const classes = {
        E: "distribuicao-email",
        P: "distribuicao-processadas",
        S: "distribuicao-sms",
        W: "distribuicao-whatsapp",
        WHATSAPP: "distribuicao-whatsapp",
        WHATSAPP_OFICIAL: "distribuicao-whatsapp",
        SMS: "distribuicao-sms",
        EMAIL: "distribuicao-email"
      };

      return classes[canal] || "distribuicao-outro";
    },

    obterSiglaDistribuicao(item) {
      if (item.isTotal) {
        return "Resumo da conta";
      }

      if (this.visaoRelatorio == "canal") {
        return `${item.percentual}% do total`;
      }

      return item.codigo || this.obterDescricaoCanal(item.canal);
    },

    inicializarValoresConsumo(destino, grupos, prefixo) {
      grupos.forEach((grupo) => {
        ["enviado", "recebido", "total"].forEach((campo) => {
          destino[this.obterChaveConsumo(prefixo, grupo.chave, campo)] = 0;
        });
      });
    },

    somarConsumo(destino, prefixo, chave, consumo) {
      ["enviado", "recebido", "total"].forEach((campo) => {
        const chaveConsumo = this.obterChaveConsumo(prefixo, chave, campo);
        destino[chaveConsumo] += Number(consumo[campo]) || 0;
      });
    },

    montarTotaisPorTipo(totaisRelatorio, consumosTotais, tiposEnvio) {
      const totais = {};

      this.inicializarValoresConsumo(
        totais,
        this.obterGruposComTotal(tiposEnvio),
        "tipo"
      );
      this.somarConsumo(totais, "tipo", "GERAL", totaisRelatorio);
      consumosTotais.forEach((consumo) => {
        const tipoEnvio = consumo.tipo_envio || {};
        this.somarConsumo(totais, "tipo", tipoEnvio.tipo_envio_id, consumo);
      });

      return totais;
    },

    montarTotaisPorCanal(totaisRelatorio, consumosTotais, canais) {
      const totais = {};

      this.inicializarValoresConsumo(
        totais,
        this.obterGruposComTotal(canais),
        "canal"
      );
      this.somarConsumo(totais, "canal", "GERAL", totaisRelatorio);
      consumosTotais.forEach((consumo) => {
        const canal = this.obterCanalConsumo(consumo).chave;
        this.somarConsumo(totais, "canal", canal, consumo);
      });

      return totais;
    },

    obterTotalGeral(campo) {
      const totais = this.totais[this.visaoRelatorio] || {};
      const chave = this.obterChaveConsumo(this.visaoRelatorio, "GERAL", campo);

      return Number(totais[chave]) || 0;
    },

    obterTotalContasResultado() {
      return this.linhas.reduce((total, linha) => {
        if (linha.isGrupoConta && linha.contas_grupo) {
          return total + linha.contas_grupo.length;
        }

        return total + 1;
      }, 0);
    },

    ehCampoConsumo(chave) {
      return /^tipo_|^canal_/.test(chave);
    },

    ehCampoTotal(chave) {
      return /_total$/.test(chave) || chave.includes("_GERAL_");
    },

    formatarValorConsumo(valor) {
      return this.formatarInteiro(Number(valor) || 0);
    },

    classeValorConsumo(chave, valor) {
      return {
        "valor-consumo-zero": Number(valor) === 0,
        "valor-consumo-total": this.ehCampoTotal(chave)
      };
    },

    classeLinhaResultado(item) {
      if (!item) {
        return "";
      }

      return {
        "linha-grupo-conta": item.isGrupoConta,
        "linha-subconta": item.agrupada,
        "linha-sem-consumo": Number(item.total) === 0
      };
    },

    obterContas(arr) {
      this.frmFiltrarRelatorio.conta = arr.map((o) => o.value);
      this.reiniciarPaginacaoFiltros();

      if (this.filtroContasAberto) {
        this.$nextTick(() => {
          if (window.requestAnimationFrame) {
            window.requestAnimationFrame(() =>
              this.aplicarAjustesPainelFiltroContas()
            );
            return;
          }

          this.aplicarAjustesPainelFiltroContas();
        });
      }
    },

    ordenarOpcoesContasFiltro(contas = this.sltContas) {
      const contasSelecionadas = new Set(
        (this.defaultsSelect.conta || []).map((conta) => Number(conta.value))
      );

      return [...contas].sort((contaA, contaB) => {
        const contaASelecionada = contasSelecionadas.has(Number(contaA.value));
        const contaBSelecionada = contasSelecionadas.has(Number(contaB.value));

        if (contaASelecionada !== contaBSelecionada) {
          return contaASelecionada ? -1 : 1;
        }

        return String(contaA.text || "").localeCompare(
          String(contaB.text || ""),
          "pt-BR",
          {
            sensitivity: "base",
            numeric: true
          }
        );
      });
    },

    limparBuscaFiltroContas() {
      const filtroContas = this.$refs.filtroContas;

      if (!filtroContas) {
        return;
      }

      filtroContas.filterValue = "";

      if (filtroContas.$refs && filtroContas.$refs.filterInput) {
        filtroContas.$refs.filterInput.value = "";
      }
    },

    ajustarPainelFiltroContas() {
      this.filtroContasAberto = true;
      this.sltContasOverlay = this.ordenarOpcoesContasFiltro();

      this.$nextTick(() => {
        const overlay = this.aplicarAjustesPainelFiltroContas();

        if (!overlay) {
          return;
        }

        this.removerCapturaFecharFiltroContas();
        const listener = (event) => this.capturarCliqueFiltroContas(event);
        overlay.addEventListener("click", listener, true);
        this.removerListenerFecharFiltroContas = () => {
          overlay.removeEventListener("click", listener, true);
        };
      });
    },

    aplicarAjustesPainelFiltroContas() {
      const filtroContas = this.$refs.filtroContas;

      if (!filtroContas || !filtroContas.$refs) {
        return null;
      }

      const overlay = filtroContas.$refs.overlay;

      if (!overlay) {
        return null;
      }

      overlay.classList.add("relatorio-consolidado-contas-overlay");
      this.posicionarPainelFiltroContas();

      const lista = overlay.querySelector(".p-multiselect-items-wrapper");

      if (lista) {
        lista.style.height = "320px";
        lista.style.maxHeight = "320px";
        lista.style.overflowY = "auto";
      }

      return overlay;
    },

    posicionarPainelFiltroContas() {
      const filtroContas = this.$refs.filtroContas;

      if (!filtroContas || !filtroContas.$refs) {
        return;
      }

      const overlay = filtroContas.$refs.overlay;
      const container = filtroContas.$refs.container;

      if (!overlay || !container) {
        return;
      }

      const retangulo = container.getBoundingClientRect();
      const largura = `${retangulo.width}px`;
      const topo = retangulo.bottom + window.pageYOffset;
      const esquerda = retangulo.left + window.pageXOffset;

      overlay.style.position = "absolute";
      overlay.style.left = `${esquerda}px`;
      overlay.style.top = `${topo}px`;
      overlay.style.right = "auto";
      overlay.style.transformOrigin = "top left";
      overlay.style.minWidth = largura;
      overlay.style.width = largura;
    },

    aoFiltrarContas() {
      this.$nextTick(() => {
        if (window.requestAnimationFrame) {
          window.requestAnimationFrame(() =>
            this.posicionarPainelFiltroContas()
          );
          return;
        }

        this.posicionarPainelFiltroContas();
      });
    },

    removerCapturaFecharFiltroContas() {
      if (!this.removerListenerFecharFiltroContas) {
        return;
      }

      this.removerListenerFecharFiltroContas();
      this.removerListenerFecharFiltroContas = null;
    },

    aoOcultarFiltroContas() {
      this.filtroContasAberto = false;
      this.sltContasOverlay = [];
      this.removerCapturaFecharFiltroContas();
      this.limparBuscaFiltroContas();
    },

    capturarCliqueFiltroContas(event) {
      const elemento = event.target;
      const botaoFechar =
        elemento &&
        elemento.closest &&
        elemento.closest(".p-multiselect-close");
      const filtroContas = this.$refs.filtroContas;

      if (
        !botaoFechar ||
        !filtroContas ||
        !filtroContas.filterValue ||
        !String(filtroContas.filterValue).trim()
      ) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (event.stopImmediatePropagation) {
        event.stopImmediatePropagation();
      }

      this.limparBuscaFiltroContas();
      this.$nextTick(() => {
        if (filtroContas.$refs && filtroContas.$refs.filterInput) {
          filtroContas.$refs.filterInput.focus();
        }
      });
    },

    textoSelectContas(contas) {
      if (!contas || contas.length === 0) {
        return "Todas";
      }

      if (contas.length === 1) {
        return contas[0].contaIntegracaoId
          ? `${contas[0].text} · Conexa ${contas[0].contaIntegracaoId}`
          : contas[0].text;
      }

      return `${contas.length} contas selecionadas`;
    },

    removerContaFiltro(contaRemovida) {
      this.defaultsSelect.conta = this.defaultsSelect.conta.filter(
        (conta) => conta.value !== contaRemovida.value
      );
      this.obterContas(this.defaultsSelect.conta);
      this.limparBuscaFiltroContas();
    },

    limparFiltroContas() {
      this.defaultsSelect.conta = [];
      this.obterContas(this.defaultsSelect.conta);
      this.limparBuscaFiltroContas();
    },

    obterResumoContaSelecionada(conta) {
      if (conta.resumoFiltro) {
        return conta.resumoFiltro;
      }

      return conta.contaIntegracaoId
        ? `Conta #${conta.value} · Conexa ${conta.contaIntegracaoId}`
        : `Conta #${conta.value}`;
    },

    obterResumoIntegracaoSelecionada(integracao) {
      if (!integracao) {
        return null;
      }

      return `${integracao.text} · ${integracao.descricaoContas}`;
    },

    limparFiltros() {
      const periodoPadrao = this.obterPeriodoPadrao();

      this.removerFiltrosSalvos();
      this.consultaRealizada = false;
      this.defaultsSelect.conta = [];
      this.defaultsSelect.periodo = periodoPadrao;
      this.defaultsSelect.faturamento = null;
      this.defaultsSelect.faturar = null;
      this.defaultsSelect.idIntegracao = null;
      this.frmFiltrarRelatorio = {
        conta: null,
        periodo: periodoPadrao.value,
        dataInicial: "",
        dataFinal: "",
        faturamento: null,
        faturar: null,
        forcarExibicaoContasSubcontas: false,
        idIntegracao: null,
        ocultarContasSemProcessamento: false,
        ocultarContasInativas: false,
        pagina: 1,
        registrosPorPagina: 20
      };
      this.paginacao = {
        paginaAtual: 1,
        registrosPorPagina: 20,
        totalRegistros: 0,
        ultimaPagina: 1
      };
    },

    obterPeriodo(obj) {
      this.frmFiltrarRelatorio.periodo = obj ? obj.value : null;
      this.normalizarPeriodoAtual();
      this.reiniciarPaginacaoFiltros();
    },

    obterFaturamento(obj) {
      this.frmFiltrarRelatorio.faturamento = obj ? obj.value : null;
      this.reiniciarPaginacaoFiltros();
    },

    obterFaturar(obj) {
      this.frmFiltrarRelatorio.faturar = obj ? obj.value : null;
      this.reiniciarPaginacaoFiltros();
    },

    obterIdIntegracao(obj) {
      this.frmFiltrarRelatorio.idIntegracao = obj
        ? this.normalizarIdIntegracao(obj.value)
        : null;
      this.reiniciarPaginacaoFiltros();
    },

    reiniciarPaginacaoFiltros() {
      this.frmFiltrarRelatorio.pagina = 1;
    },

    alterarPagina(pagina) {
      this.obterPaginaRelatorio(pagina);
    },

    alterarRegistrosPorPagina(registrosPorPagina) {
      this.frmFiltrarRelatorio.registrosPorPagina =
        this.normalizarRegistrosPorPagina(registrosPorPagina);
      this.obterPaginaRelatorio(1);
    },

    async detalhes(linha) {
      if (!linha.detailsShowing) {
        const filtros = { ...this.ultimosFiltrosUtilizados };
        filtros.conta = [linha.item.conta];

        await ApiService.post(
          "relatorio/consolidado/obter-detalhes-consolidado",
          filtros
        ).then((res) => {
          this.detalhesContas[linha.index] = res.data.data;
        });
      }

      linha.toggleDetails();
    },

    async mensagens(linha) {
      const filtros = { ...this.ultimosFiltrosUtilizados };
      filtros.conta = [linha.item.conta];

      await ApiService.post(
        "relatorio/consolidado/obter-custos-mensagens-consolidado",
        filtros
      ).then((res) => {
        this.custoMensagemsSelecionada = res.data;
        if (!this.custoMensagemsSelecionada.length) {
          this.$toast.add({
            severity: "info",
            summary: "Sem informações de custos",
            detail:
              "O sistema não retornou nenhum custo para " +
              linha.item.nome_conta,
            life: 7000
          });
          return;
        }
        this.$refs.mdlCustoMensagens.abrir();
      });
    },

    alternarContasSelecionadas(selecionar = this.todasContasSelecionadas) {
      this.contasSelecionadas = selecionar
        ? this.obterContasSelecionaveisCobranca()
        : [];
    },

    gerarCobrancaMultipla(contas) {
      const contasParaFaturar = Array.isArray(contas)
        ? contas
        : this.contasSelecionadas;
      const contasSelecionaveis = this.removerContasDuplicadasCobranca(
        contasParaFaturar.filter((conta) => this.contaPodeFaturar(conta))
      );

      if (contasSelecionaveis.length === 0) {
        Swal.fire({
          title: "MENSAGEM",
          text: "Selecione ao menos uma conta com integração para faturar no período de mês anterior.",
          icon: "warning",
          heightAuto: false
        });
        return;
      }

      this.prepararFilaCobranca(contasSelecionaveis);
      this.$refs.mdlProcessamentoCobranca.show();
    },

    prepararFilaCobranca(contas) {
      const contasUnicas = this.removerContasDuplicadasCobranca(contas);

      this.dataVendaCobranca = this.obterDataVendaPadraoCobranca();
      this.cobrancaEmProcessamento = false;
      this.cobrancaCancelada = false;
      this.cobrancaFinalizada = false;
      this.filaCobranca = contasUnicas.map((conta) => ({
        conta: this.obterIdContaCobranca(conta),
        nome_conta:
          conta.nome_conta || `Conta ${this.obterIdContaCobranca(conta)}`,
        jaFaturada: this.contaJaFaturada(conta),
        faturadaPorGrupo: this.contaFaturadaPorGrupo(conta),
        detalheFaturamento: this.obterDetalheFaturamentoConta(conta),
        conta_principal_id: conta.conta_principal_id,
        agrupar_faturamento: conta.agrupar_faturamento,
        status: "aguardando",
        mensagem: "Aguardando processamento.",
        resultados: [],
        quantidadeFaturada: 0,
        resumoTiposCobranca: [],
        contaPrincipalCobranca: "",
        contasAgrupadasCobranca: []
      }));
    },

    obterDataVendaPadraoCobranca() {
      return moment()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
    },

    obterDataVendaCobrancaIso() {
      return moment(this.dataVendaCobranca, "YYYY-MM-DD")
        .startOf("day")
        .toISOString(true);
    },

    async iniciarProcessamentoCobranca() {
      if (!moment(this.dataVendaCobranca, "YYYY-MM-DD", true).isValid()) {
        Swal.fire({
          title: "MENSAGEM",
          text: "Informe uma data da venda válida.",
          icon: "warning",
          heightAuto: false
        });
        return;
      }

      this.cobrancaEmProcessamento = true;
      this.cobrancaCancelada = false;
      this.cobrancaFinalizada = false;

      for (let index = 0; index < this.filaCobranca.length; index += 1) {
        if (this.cobrancaCancelada) {
          this.marcarCobrancasRestantesComoCanceladas(index);
          break;
        }

        await this.processarItemCobranca(index);
      }

      this.cobrancaEmProcessamento = false;
      this.cobrancaFinalizada = true;
    },

    async processarItemCobranca(index) {
      const item = this.filaCobranca[index];
      this.atualizarItemFilaCobranca(index, {
        status: "processando",
        mensagem: "Enviando cobrança para o backend."
      });
      this.rolarParaItemCobranca(index);

      try {
        const response = await ApiService.post(
          "conta/integracao/gerar-cobranca-multipla",
          {
            contas: [item.conta],
            dataVenda: this.obterDataVendaCobrancaIso()
          }
        );
        const resultado = this.normalizarResultadoCobrancaConta(
          item,
          response.data
        );

        this.atualizarItemFilaCobranca(index, resultado);
      } catch (e) {
        this.atualizarItemFilaCobranca(index, {
          status: "erro",
          mensagem: "Erro inesperado ao processar a cobrança.",
          resultados: [],
          quantidadeFaturada: 0
        });
      }
    },

    normalizarResultadoCobrancaConta(item, retorno) {
      const resultados = this.obterResultadosCobranca(retorno && retorno.data);
      const resultadosConta = resultados.filter(
        (resultado) => Number(resultado.conta_id) === Number(item.conta)
      );
      const resultadosNormalizados =
        resultadosConta.length > 0 ? resultadosConta : resultados;
      const possuiAviso = resultadosNormalizados.some(
        (resultado) => resultado.status === "warning"
      );
      const possuiErro =
        (retorno && retorno.status && retorno.status !== "success") ||
        resultadosNormalizados.some(
          (resultado) => !["success", "warning"].includes(resultado.status)
        );
      const quantidadeFaturada = resultadosNormalizados.reduce(
        (total, resultado) => {
          const dados = resultado.data || {};

          return (
            total +
            this.obterPrimeiroNumero([
              dados.quantidade_faturado,
              dados.quantidade_faturado_grupo
            ])
          );
        },
        0
      );
      const contaPrincipalCobranca = possuiAviso
        ? this.obterDescricaoContaPrincipalCobranca(item, retorno)
        : "";
      const mensagem =
        this.obterMensagemResultadoCobranca(
          resultadosNormalizados,
          contaPrincipalCobranca
        ) ||
        (retorno && retorno.message) ||
        "Processamento concluído.";

      return {
        status: possuiErro ? "erro" : possuiAviso ? "aviso" : "concluido",
        mensagem,
        resultados: resultadosNormalizados,
        quantidadeFaturada,
        resumoTiposCobranca: this.montarResumoTiposCobranca(
          resultadosNormalizados
        ),
        contaPrincipalCobranca,
        contasAgrupadasCobranca: possuiAviso
          ? []
          : this.obterContasAgrupadasCobranca(item)
      };
    },

    obterResultadosCobranca(retorno) {
      if (Array.isArray(retorno)) {
        return retorno;
      }

      return Object.values(retorno || {}).reduce((resultados, item) => {
        if (Array.isArray(item)) {
          return resultados.concat(item);
        }

        if (item && typeof item === "object") {
          return resultados.concat(this.obterResultadosCobranca(item));
        }

        return resultados;
      }, []);
    },

    obterMensagemResultadoCobranca(resultados, contaPrincipalCobranca = "") {
      const mensagens = resultados
        .map((resultado) => resultado.message)
        .filter(
          (mensagem, index, mensagensResultado) =>
            mensagem && mensagensResultado.indexOf(mensagem) === index
        );

      if (contaPrincipalCobranca) {
        mensagens.push(`Processamento vinculado a ${contaPrincipalCobranca}.`);
      }

      return mensagens.join(" | ") || "Processamento concluído.";
    },

    montarResumoTiposCobranca(resultados) {
      return resultados
        .filter((resultado) => resultado && resultado.data)
        .map((resultado, index) => {
          const dados = resultado.data || {};
          const tipoEnvio = dados.tipo_envio || {};
          const plano = dados.plano || {};

          return {
            chave: `${tipoEnvio.tipo_envio_id || index}-${index}`,
            descricao: tipoEnvio.tev_descricao || "Tipo não informado",
            codigo: tipoEnvio.tev_codigo || tipoEnvio.mtp_sigla || "",
            quantidade: this.obterPrimeiroNumero([
              dados.quantidade,
              dados.total
            ]),
            quantidadeFaturada: this.obterPrimeiroNumero([
              dados.quantidade_faturado,
              dados.quantidade_faturado_grupo
            ]),
            quantidadeGrupo: this.obterPrimeiroNumero([
              dados.quantidade_grupo,
              dados.quantidade_faturado_grupo
            ]),
            plano:
              plano.nome_plano ||
              plano.pla_nome ||
              plano.pla_integracao_id ||
              "-"
          };
        });
    },

    obterDescricaoContaPrincipalCobranca(item, retorno) {
      const idPrincipalRetorno = this.obterIdContaPrincipalRetornoCobranca(
        retorno && retorno.data,
        item.conta
      );
      const idPrincipal = idPrincipalRetorno || item.conta_principal_id;
      const contaPrincipal = this.filaCobranca.find(
        (conta) => Number(conta.conta) === Number(idPrincipal)
      );

      if (!idPrincipal) {
        return "";
      }

      return contaPrincipal
        ? `${contaPrincipal.nome_conta} (${contaPrincipal.conta})`
        : `Conta ${idPrincipal}`;
    },

    obterIdContaPrincipalRetornoCobranca(retorno, idConta) {
      const grupos = retorno && typeof retorno === "object" ? retorno : {};
      const entrada = Object.entries(grupos).find(([, resultados]) =>
        this.obterResultadosCobranca(resultados).some(
          (resultado) => Number(resultado.conta_id) === Number(idConta)
        )
      );

      return entrada ? entrada[0] : null;
    },

    obterContasAgrupadasCobranca(item) {
      const idPrincipal = item.conta_principal_id || item.conta;

      return this.filaCobranca
        .filter(
          (conta) =>
            Number(conta.conta) !== Number(item.conta) &&
            (Number(conta.conta_principal_id) === Number(idPrincipal) ||
              Number(conta.conta) === Number(idPrincipal))
        )
        .map((conta) => `${conta.nome_conta} (${conta.conta})`);
    },

    atualizarItemFilaCobranca(index, dados) {
      this.$set(this.filaCobranca, index, {
        ...this.filaCobranca[index],
        ...dados
      });
    },

    rolarParaItemCobranca(index) {
      this.$nextTick(() => {
        const container = this.$refs.cobrancaFila;
        const itemRef = this.$refs["cobrancaFilaItem-" + index];
        const elemento = Array.isArray(itemRef) ? itemRef[0] : itemRef;

        if (!container || !elemento) {
          return;
        }

        const margem = 16;
        const containerRect = container.getBoundingClientRect();
        const itemRect = elemento.getBoundingClientRect();
        const topo = Math.max(
          itemRect.top - containerRect.top + container.scrollTop - margem,
          0
        );

        if (typeof container.scrollTo === "function") {
          container.scrollTo({ top: topo, behavior: "smooth" });
          return;
        }

        container.scrollTop = topo;
      });
    },

    marcarCobrancasRestantesComoCanceladas(indiceInicial) {
      for (
        let index = indiceInicial;
        index < this.filaCobranca.length;
        index += 1
      ) {
        if (this.filaCobranca[index].status === "aguardando") {
          this.atualizarItemFilaCobranca(index, {
            status: "cancelado",
            mensagem: "Processamento cancelado antes do envio."
          });
        }
      }
    },

    cancelarProcessamentoCobranca() {
      this.cobrancaCancelada = true;
    },

    fecharModalCobranca() {
      this.$refs.mdlProcessamentoCobranca.hide();
    },

    sincronizarContasSelecionadasComVisualizacao() {
      const contasSelecionadasIds = this.contasSelecionadas
        .map((conta) => Number(this.obterIdContaCobranca(conta)))
        .filter((idConta) => !!idConta);

      if (contasSelecionadasIds.length === 0) {
        this.todasContasSelecionadas = false;
        return;
      }

      this.contasSelecionadas = this.obterContasSelecionaveisCobranca().filter(
        (conta) =>
          contasSelecionadasIds.includes(
            Number(this.obterIdContaCobranca(conta))
          )
      );
    },

    obterContasSelecionaveisCobranca() {
      const contas = this.linhas.reduce((contas, linha) => {
        if (linha.isGrupoConta && linha.contas_grupo) {
          return contas.concat(
            linha.contas_grupo.filter((conta) => this.contaPodeFaturar(conta))
          );
        }

        if (this.contaPodeFaturar(linha)) {
          contas.push(linha);
        }

        return contas;
      }, []);

      return this.removerContasDuplicadasCobranca(contas);
    },

    removerContasDuplicadasCobranca(contas) {
      const contasIncluidas = [];

      return contas.filter((conta) => {
        const idConta = this.obterIdContaCobranca(conta);

        if (!idConta || contasIncluidas.includes(Number(idConta))) {
          return false;
        }

        contasIncluidas.push(Number(idConta));
        return true;
      });
    },

    obterFaturamentoConta(conta) {
      return (conta && conta.conta_faturamento) || {};
    },

    contaJaFaturada(conta) {
      const faturamento = this.obterFaturamentoConta(conta);
      const valor =
        conta && conta.faturado !== undefined
          ? conta.faturado
          : faturamento.faturado;

      return ["S", "SIM", "1", 1, true, "TRUE"].includes(
        typeof valor === "string" ? valor.toUpperCase() : valor
      );
    },

    obterIdContaFaturada(conta) {
      const faturamento = this.obterFaturamentoConta(conta);

      return (
        conta &&
        (conta.conta_faturada_id ||
          faturamento.conta_faturada_id ||
          faturamento.conta_id)
      );
    },

    contaFaturadaPorGrupo(conta) {
      const contaFaturadaId = this.obterIdContaFaturada(conta);
      const contaId = this.obterIdContaCobranca(conta);

      return (
        this.contaJaFaturada(conta) &&
        contaFaturadaId &&
        contaId &&
        Number(contaFaturadaId) !== Number(contaId)
      );
    },

    obterResumoFaturamentoGrupo(grupo) {
      const contas = grupo && grupo.contas_grupo ? grupo.contas_grupo : [];
      const faturadas = contas.filter((conta) => this.contaJaFaturada(conta));

      return {
        total: contas.length,
        faturadas: faturadas.length,
        primeiraContaFaturada: faturadas[0] || null
      };
    },

    obterStatusFaturamentoConta(conta) {
      if (conta && conta.isGrupoConta && conta.contas_grupo) {
        const resumo = this.obterResumoFaturamentoGrupo(conta);

        if (resumo.faturadas === 0) {
          return "pendente";
        }

        return resumo.faturadas === resumo.total ? "faturada" : "parcial";
      }

      if (this.contaFaturadaPorGrupo(conta)) {
        return "grupo";
      }

      return this.contaJaFaturada(conta) ? "faturada" : "pendente";
    },

    deveExibirFaturamentoConta() {
      return this.ultimosFiltrosUtilizados.periodo == "MAN";
    },

    obterTextoBadgeFaturamento(conta) {
      const textos = {
        faturada: conta && conta.isGrupoConta ? "Faturado" : "Faturada",
        grupo: "Faturada no grupo",
        parcial: "Parcial",
        pendente: "Pendente"
      };

      return textos[this.obterStatusFaturamentoConta(conta)] || "Pendente";
    },

    obterClasseBadgeFaturamento(conta) {
      return `conta-badge-faturamento-${this.obterStatusFaturamentoConta(
        conta
      )}`;
    },

    formatarDataFaturamento(data) {
      const dataFaturamento = moment(
        data,
        ["YYYY-MM-DD HH:mm:ss", moment.ISO_8601],
        true
      );

      return dataFaturamento.isValid()
        ? dataFaturamento.format("DD/MM/YYYY HH:mm")
        : "";
    },

    obterDetalheFaturamentoConta(conta) {
      if (conta && conta.isGrupoConta && conta.contas_grupo) {
        const resumo = this.obterResumoFaturamentoGrupo(conta);
        const partes = [`${resumo.faturadas}/${resumo.total} contas faturadas`];
        const data = this.formatarDataFaturamento(
          resumo.primeiraContaFaturada &&
            resumo.primeiraContaFaturada.faturamento_data
        );

        if (data) {
          partes.push(`em ${data}`);
        }

        return partes.join(" - ");
      }

      if (!this.contaJaFaturada(conta)) {
        return "Ainda não faturada no período";
      }

      const partes = [];
      const contaFaturadaId = this.obterIdContaFaturada(conta);
      const quantidade =
        conta &&
        this.obterPrimeiroNumero([
          conta.faturamento_quantidade_total,
          this.obterFaturamentoConta(conta).quantidade_total
        ]);
      const data = this.formatarDataFaturamento(
        conta &&
          (conta.faturamento_data ||
            this.obterFaturamentoConta(conta).data_faturamento)
      );

      if (this.contaFaturadaPorGrupo(conta)) {
        partes.push(`Faturada junto com a conta ${contaFaturadaId}`);
      }

      if (quantidade) {
        partes.push(`${this.formatarValorConsumo(quantidade)} faturados`);
      }

      if (data) {
        partes.push(`em ${data}`);
      }

      return partes.join(" - ") || "Faturada no período";
    },

    obterQuantidadeFaturadaConta(conta) {
      const faturamento = this.obterFaturamentoConta(conta);

      return this.obterPrimeiroNumero([
        conta && conta.faturamento_quantidade_total,
        faturamento.quantidade_total
      ]);
    },

    obterCobrancasFaturamento(conta) {
      const faturamento = this.obterFaturamentoConta(conta);

      return Array.isArray(faturamento.cobrancas) ? faturamento.cobrancas : [];
    },

    obterObservacoesFaturamentoConta(conta) {
      const faturamento = this.obterFaturamentoConta(conta);
      const observacoes = faturamento.observacoes_faturamento;

      if (Array.isArray(observacoes)) {
        return observacoes.filter(Boolean);
      }

      return observacoes ? [observacoes] : [];
    },

    deveExibirDetalhesCobrancasConta(conta) {
      if (
        !this.deveExibirFaturamentoConta(conta) ||
        !this.contaJaFaturada(conta)
      ) {
        return false;
      }

      return (
        this.obterCobrancasFaturamento(conta).length > 0 ||
        this.obterObservacoesFaturamentoConta(conta).length > 0
      );
    },

    abrirDetalhesCobrancasConta(conta) {
      this.detalheFaturamentoSelecionado = conta;

      this.$nextTick(() => {
        this.$refs.mdlDetalhesFaturamento.show();
      });
    },

    obterChaveCobrancaFaturamento(cobranca) {
      return [
        cobranca.conta_id,
        cobranca.grupo_tipo_envio_id,
        cobranca.plano,
        cobranca.data_faturamento
      ]
        .filter(Boolean)
        .join("-");
    },

    obterGrupoCobranca(cobranca) {
      return (
        (cobranca.dados_calculados &&
          cobranca.dados_calculados.grupo_tipo_envio) ||
        (cobranca.resposta_integracao &&
          cobranca.resposta_integracao.grupo_tipo_envio) ||
        {}
      );
    },

    obterDescricaoGrupoCobranca(cobranca) {
      const grupo = this.obterGrupoCobranca(cobranca);

      return (
        grupo.gte_descricao ||
        grupo.gte_codigo ||
        `Grupo ${cobranca.grupo_tipo_envio_id || "não informado"}`
      );
    },

    obterQuantidadeCobranca(cobranca) {
      return this.obterPrimeiroNumero([
        cobranca.quantidade,
        cobranca.dados_calculados &&
          cobranca.dados_calculados.quantidade_faturada_total
      ]);
    },

    obterPlanoCobranca(cobranca) {
      const itens = this.obterItensCobrancaFaturamento(cobranca);
      const plano = itens.length > 0 ? itens[0].plano || {} : {};
      const codigoPlano =
        cobranca.plano || plano.pla_integracao_id || plano.plano_id;
      const nomePlano = plano.nome_plano || plano.pla_nome;

      return nomePlano ? `${codigoPlano} - ${nomePlano}` : codigoPlano || "-";
    },

    obterIdsVendaConexaCobranca(cobranca) {
      const respostas =
        cobranca.resposta_integracao && cobranca.resposta_integracao.respostas;

      if (!Array.isArray(respostas) || respostas.length === 0) {
        return [];
      }

      return respostas
        .map((resposta) => resposta && resposta.json && resposta.json.id)
        .filter(Boolean);
    },

    obterUrlVendaConexa(idVenda) {
      return `https://w3.conexa.app/index.php?r=venda/view&id=${idVenda}`;
    },

    obterItensCobrancaFaturamento(cobranca) {
      const itens =
        cobranca.dados_calculados && cobranca.dados_calculados.itens;

      return Array.isArray(itens) ? itens : [];
    },

    obterChaveItemCobrancaFaturamento(cobranca, item) {
      const tipoEnvio = item.tipo_envio || {};

      return [
        this.obterChaveCobrancaFaturamento(cobranca),
        tipoEnvio.tipo_envio_id,
        item.canal && item.canal.codigo
      ]
        .filter(Boolean)
        .join("-");
    },

    obterDescricaoTipoCobranca(item) {
      const tipoEnvio = item.tipo_envio || {};

      return tipoEnvio.tev_descricao || "Tipo não informado";
    },

    obterCodigoTipoCobranca(item) {
      const tipoEnvio = item.tipo_envio || {};
      const canal = item.canal && item.canal.descricao;

      return canal || tipoEnvio.tev_codigo || "-";
    },

    contaPodeFaturar(conta) {
      return (
        this.isAdmin &&
        this.ultimosFiltrosUtilizados.periodo == "MAN" &&
        !!this.obterCodigoConexa(conta) &&
        this.contaHabilitadaFaturamento(conta)
      );
    },

    contaHabilitadaFaturamento(conta) {
      const valor = [
        conta && conta.faturar,
        conta && conta.habilitada_faturamento,
        conta && conta.habilitado_faturamento,
        conta && conta.faturamento_habilitado,
        conta && conta.conta_habilitada_faturamento,
        conta && conta.habilitada_para_faturamento,
        conta && conta.pode_faturar
      ].find((item) => item !== undefined && item !== null && item !== "");

      if (valor === undefined) {
        return true;
      }

      return ["S", "SIM", "1", 1, true, "TRUE"].includes(
        typeof valor === "string" ? valor.toUpperCase() : valor
      );
    },

    obterIdContaCobranca(conta) {
      return conta && (conta.conta || conta.id);
    },

    obterTextoStatusCobranca(status) {
      const textos = {
        aguardando: "Aguardando",
        processando: "Processando",
        concluido: "Concluído",
        aviso: "Aviso",
        erro: "Erro",
        cancelado: "Cancelado"
      };

      return textos[status] || status;
    }
  },
  computed: {
    ...mapGetters(["isAdmin"]),
    qtdContasSelecionadas() {
      return this.contasSelecionadas.length || 0;
    },

    contasSelecionaveisCobranca() {
      return this.obterContasSelecionaveisCobranca();
    },

    exibirSelecaoCobranca() {
      return (
        this.isAdmin &&
        this.ultimosFiltrosUtilizados.periodo == "MAN" &&
        this.contasSelecionaveisCobranca.length > 0
      );
    },

    exibirDatasPeriodo() {
      return this.frmFiltrarRelatorio.periodo == "personalizado";
    },

    resumoProcessamentoCobranca() {
      return this.filaCobranca.reduce(
        (resumo, item) => {
          if (item.status === "concluido") {
            resumo.concluidas += 1;
          }

          if (item.status === "aviso") {
            resumo.avisos += 1;
          }

          if (item.status === "erro") {
            resumo.erros += 1;
          }

          if (item.status === "cancelado") {
            resumo.canceladas += 1;
          }

          if (
            ["concluido", "aviso", "erro", "cancelado"].includes(item.status)
          ) {
            resumo.processadas += 1;
          }

          resumo.faturado += Number(item.quantidadeFaturada) || 0;

          return resumo;
        },
        {
          concluidas: 0,
          avisos: 0,
          erros: 0,
          canceladas: 0,
          processadas: 0,
          faturado: 0
        }
      );
    },

    percentualProcessamentoCobranca() {
      if (this.filaCobranca.length === 0) {
        return 0;
      }

      return Math.round(
        (this.resumoProcessamentoCobranca.processadas /
          this.filaCobranca.length) *
          100
      );
    },

    textoProgressoCobranca() {
      return `${this.resumoProcessamentoCobranca.processadas} de ${this.filaCobranca.length} contas processadas`;
    },

    sltContasOrdenadas() {
      if (this.filtroContasAberto && this.sltContasOverlay.length > 0) {
        return this.sltContasOverlay;
      }

      return this.ordenarOpcoesContasFiltro();
    },

    contasSelecionadasFiltroOrdenadas() {
      return [...(this.defaultsSelect.conta || [])].sort((contaA, contaB) =>
        String(contaA.text || "").localeCompare(
          String(contaB.text || ""),
          "pt-BR",
          {
            sensitivity: "base",
            numeric: true
          }
        )
      );
    },

    resumoResultado() {
      return [
        {
          chave: "contas",
          label: "Contas",
          valor: this.formatarValorConsumo(this.obterTotalContasResultado()),
          descricao: "contas na página atual"
        },
        {
          chave: "enviado",
          label: "Enviado",
          valor: this.formatarValorConsumo(this.obterTotalGeral("enviado")),
          descricao: "mensagens enviadas na página atual"
        },
        {
          chave: "recebido",
          label: "Recebido",
          valor: this.formatarValorConsumo(this.obterTotalGeral("recebido")),
          descricao: "mensagens recebidas na página atual"
        },
        {
          chave: "total",
          label: "Total",
          valor: this.formatarValorConsumo(this.obterTotalGeral("total")),
          descricao: `página atual por ${
            this.visaoRelatorio == "tipo" ? "tipo de envio" : "canal"
          }`
        }
      ];
    },

    resultadoAgrupadoDisponivel() {
      return this.resultadoAgrupado.some((linha) => linha.isGrupoConta);
    },

    exibirResultadoAgrupado() {
      return this.exibirAgrupado && this.resultadoAgrupadoDisponivel;
    },

    filtrosAtivos() {
      const filtros = [];

      if (this.defaultsSelect.conta.length > 0) {
        filtros.push("conta");
      }

      if (this.frmFiltrarRelatorio.periodo != this.obterPeriodoPadrao().value) {
        filtros.push("periodo");
      }

      if (this.frmFiltrarRelatorio.dataInicial) {
        filtros.push("dataInicial");
      }

      if (this.frmFiltrarRelatorio.dataFinal) {
        filtros.push("dataFinal");
      }

      if (this.defaultsSelect.faturamento) {
        filtros.push("faturamento");
      }

      if (this.defaultsSelect.faturar) {
        filtros.push("faturar");
      }

      if (this.frmFiltrarRelatorio.idIntegracao) {
        filtros.push("idIntegracao");
      }

      if (this.frmFiltrarRelatorio.forcarExibicaoContasSubcontas) {
        filtros.push("forcarExibicaoContasSubcontas");
      }

      if (this.frmFiltrarRelatorio.ocultarContasSemProcessamento) {
        filtros.push("ocultarContasSemProcessamento");
      }

      if (this.frmFiltrarRelatorio.ocultarContasInativas) {
        filtros.push("ocultarContasInativas");
      }

      return filtros;
    },

    possuiFiltrosAtivos() {
      return this.filtrosAtivos.length > 0;
    },

    quantidadeFiltrosAtivos() {
      return this.filtrosAtivos.length;
    },

    textoFiltrosAtivos() {
      const quantidade = this.quantidadeFiltrosAtivos;
      const plural = quantidade === 1 ? "filtro ativo" : "filtros ativos";

      return `${quantidade} ${plural}`;
    },

    resumoFiltros() {
      const filtros = [];

      if (this.defaultsSelect.periodo) {
        filtros.push({
          chave: "periodo",
          label: "Período",
          valor: this.defaultsSelect.periodo.text
        });
      }

      if (this.exibirDatasPeriodo) {
        if (this.frmFiltrarRelatorio.dataInicial) {
          filtros.push({
            chave: "dataInicial",
            label: "Data inicial",
            valor: this.frmFiltrarRelatorio.dataInicial
          });
        }

        if (this.frmFiltrarRelatorio.dataFinal) {
          filtros.push({
            chave: "dataFinal",
            label: "Data final",
            valor: this.frmFiltrarRelatorio.dataFinal
          });
        }
      }

      if (this.defaultsSelect.faturamento) {
        filtros.push({
          chave: "faturamento",
          label: "Lançamento",
          valor: this.defaultsSelect.faturamento.text
        });
      }

      if (this.defaultsSelect.faturar) {
        filtros.push({
          chave: "faturar",
          label: "Faturar",
          valor: this.defaultsSelect.faturar.text
        });
      }

      if (this.frmFiltrarRelatorio.idIntegracao) {
        filtros.push({
          chave: "idIntegracao",
          label: "ID integração",
          valor:
            this.obterResumoIntegracaoSelecionada(
              this.defaultsSelect.idIntegracao
            ) || this.frmFiltrarRelatorio.idIntegracao
        });
      }

      if (this.frmFiltrarRelatorio.forcarExibicaoContasSubcontas) {
        filtros.push({
          chave: "forcarExibicaoContasSubcontas",
          label: "Contas e subcontas",
          valor: "Forçar exibição"
        });
      }

      if (this.frmFiltrarRelatorio.ocultarContasSemProcessamento) {
        filtros.push({
          chave: "ocultarContasSemProcessamento",
          label: "Processamento",
          valor: "Ocultar contas sem processamento"
        });
      }

      if (this.frmFiltrarRelatorio.ocultarContasInativas) {
        filtros.push({
          chave: "ocultarContasInativas",
          label: "Status da conta",
          valor: "Ocultar contas inativas"
        });
      }

      return filtros;
    },

    cabecalho() {
      const obj = JSON.parse(
        JSON.stringify(this.cabecalhos[this.visaoRelatorio])
      );

      if (this.exibirSelecaoCobranca) {
        obj.cabecalho.unshift({
          key: "selecionar",
          label: "Selecionar",
          sortable: false,
          class: "text-center align-middle"
        });
      }

      obj.cabecalho.push({
        key: "acoes",
        label: "Ações",
        sortable: false,
        class: "text-center coluna-acoes",
        tdClass: "text-center coluna-acoes",
        thStyle: { width: "246px" }
      });

      return obj;
    },

    linhas() {
      return this.exibirResultadoAgrupado
        ? this.resultadoAgrupado
        : this.resultado;
    },

    total() {
      const obj = JSON.parse(JSON.stringify(this.totais[this.visaoRelatorio]));
      obj.acoes = "";
      return obj;
    },

    totalRegistrosPaginacao() {
      return this.paginacao.totalRegistros || 0;
    },

    registrosPorPaginaAtual() {
      return this.paginacao.registrosPorPagina || 20;
    },

    textoPeriodo() {
      return this.sltPeriodos.find(
        (i) => i.value == this.ultimosFiltrosUtilizados.periodo
      )?.text;
    }
  },
  watch: {
    exibirAgrupado() {
      this.sincronizarContasSelecionadasComVisualizacao();
    },

    contasSelecionadas(contasSelecionadas) {
      const contasSelecionaveis = this.obterContasSelecionaveisCobranca();

      this.todasContasSelecionadas =
        contasSelecionadas.length > 0 &&
        contasSelecionaveis.length === contasSelecionadas.length
          ? true
          : false;
    }
  }
};
</script>

<style scoped>
.filtros-card-title {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.55rem;
}

.filtros-ativos-indicador {
  background: #fff8dd;
  border: 1px solid #ffe7a3;
  border-radius: 4px;
  color: #946200;
  font-size: 0.78rem;
  font-weight: 700;
  line-height: 1;
  padding: 0.35rem 0.5rem;
  text-transform: uppercase;
  white-space: nowrap;
}

.card-toolbar {
  align-items: center;
  display: flex;
  gap: 0.45rem;
}

.btn-gerar-cobranca,
.btn-acao {
  align-items: center;
  border-radius: 4px;
  display: inline-flex;
  justify-content: center;
  letter-spacing: 0;
  min-height: 34px;
}

.btn-gerar-cobranca {
  padding-left: 0.95rem;
  padding-right: 0.95rem;
}

.visao-relatorio-toggle,
.visualizacao-agrupamento-toggle {
  display: inline-flex;
}

.visao-relatorio-toggle >>> .btn,
.visualizacao-agrupamento-toggle >>> .btn {
  align-items: center;
  border-color: #d7deed;
  color: #3f4254;
  display: inline-flex;
  font-weight: 700;
  justify-content: center;
  letter-spacing: 0;
  min-height: 36px;
  min-width: 96px;
  padding: 0.45rem 0.8rem;
}

.visao-relatorio-toggle >>> .btn.active,
.visao-relatorio-toggle >>> .btn:not(:disabled):not(.disabled):active,
.visualizacao-agrupamento-toggle >>> .btn.active,
.visualizacao-agrupamento-toggle >>> .btn:not(:disabled):not(.disabled):active {
  background: #3699ff;
  border-color: #3699ff;
  color: #ffffff;
}

.visao-relatorio-toggle >>> .btn:focus,
.visualizacao-agrupamento-toggle >>> .btn:focus {
  box-shadow: none;
}

.resultado-resumo {
  display: grid;
  gap: 0.85rem;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  margin-bottom: 1.1rem;
}

.resultado-indicador {
  background: #f8fafc;
  border: 1px solid #eef0f8;
  border-left: 3px solid #3699ff;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: 0.95rem 1rem;
}

.resultado-indicador-label {
  color: #7e8299;
  font-size: 0.92rem;
  font-weight: 600;
  text-transform: uppercase;
}

.resultado-indicador-valor {
  color: #181c32;
  font-size: 1.5rem;
  line-height: 1.2;
  margin-top: 0.2rem;
}

.resultado-indicador-descricao {
  color: #7e8299;
  font-size: 0.88rem;
  margin-top: 0.15rem;
}

.legenda-canais {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

.legenda-item {
  align-items: center;
  background: #f8fafc;
  border: 1px solid #eef0f8;
  border-radius: 4px;
  color: #3f4254;
  display: inline-flex;
  font-size: 0.92rem;
  font-weight: 600;
  gap: 0.35rem;
  line-height: 1;
  padding: 0.45rem 0.6rem;
}

.legenda-item::before {
  border-radius: 50%;
  content: "";
  display: inline-block;
  height: 8px;
  width: 8px;
}

.legenda-whatsapp::before {
  background: #1bc5bd;
}

.legenda-sms::before {
  background: #ffa800;
}

.legenda-email::before {
  background: #3699ff;
}

.legenda-processadas::before {
  background: #8950fc;
}

.legenda-outro::before {
  background: #7e8299;
}

.relatorio-grupos {
  display: grid;
  gap: 1rem;
}

.relatorio-grupo-card {
  background: #ffffff;
  border: 1px solid #dfe5f2;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(63, 66, 84, 0.05);
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
}

.relatorio-grupo-cabecalho {
  align-items: flex-start;
  background: #f8fafc;
  border-bottom: 1px solid #dfe5f2;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  padding: 1rem;
}

.relatorio-grupo-totais {
  display: grid;
  gap: 0.5rem;
  grid-template-columns: repeat(3, minmax(88px, 1fr)) auto;
  min-width: 420px;
}

.relatorio-grupo-totais div {
  background: #ffffff;
  border: 1px solid #eef0f8;
  border-radius: 4px;
  padding: 0.55rem 0.65rem;
}

.relatorio-grupo-totais span {
  color: #7e8299;
  display: block;
  font-size: 0.76rem;
  font-weight: 700;
  text-transform: uppercase;
}

.relatorio-grupo-totais strong {
  color: #181c32;
  display: block;
  font-size: 1rem;
  margin-top: 0.15rem;
  text-align: right;
}

.relatorio-grupo-conteudo {
  display: grid;
  gap: 1rem;
  grid-template-columns: minmax(360px, 0.75fr) minmax(0, 1.25fr);
  min-width: 0;
  padding: 1rem;
}

.relatorio-grupo-composicao,
.relatorio-grupo-contas {
  min-width: 0;
}

.relatorio-grupo-composicao {
  order: 2;
}

.relatorio-grupo-conteudo-sem-contas {
  grid-template-columns: minmax(0, 1fr);
}

.relatorio-grupo-conteudo-sem-contas .relatorio-grupo-composicao {
  order: 1;
}

.relatorio-grupo-composicao .distribuicao-consumo {
  min-width: 0;
}

.relatorio-grupo-contas {
  order: 1;
  background: #f8fafc;
  border: 1px solid #eef0f8;
  border-radius: 4px;
  max-width: 100%;
  padding: 0.75rem;
}

.relatorio-grupo-contas-titulo {
  color: #3f4254;
  font-size: 0.82rem;
  font-weight: 700;
  margin-bottom: 0.55rem;
  text-transform: uppercase;
}

.relatorio-grupo-conta {
  background: #ffffff;
  border: 1px solid #eef0f8;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  padding: 0.65rem;
}

.relatorio-grupo-conta + .relatorio-grupo-conta {
  margin-top: 0.5rem;
}

.relatorio-grupo-conta-topo {
  align-items: start;
  display: grid;
  gap: 0.75rem;
  grid-template-columns: auto minmax(0, 1fr) auto;
  min-width: 0;
}

.relatorio-grupo-conta-selecao {
  min-width: 24px;
}

.relatorio-grupo-conta-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.relatorio-grupo-conta-info strong,
.relatorio-grupo-conta-info small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.relatorio-grupo-conta-info strong {
  color: #181c32;
  font-size: 0.84rem;
}

.relatorio-grupo-conta-info small {
  color: #7e8299;
  font-size: 0.8rem;
}

.relatorio-grupo-conta-resumo {
  min-width: 0;
}

.relatorio-grupo-conta-info .conta-celula-badges {
  gap: 0.25rem;
  margin-top: 0.35rem;
  min-width: 0;
}

.relatorio-grupo-conta-tipos {
  background: #ffffff;
  border: 1px solid #eef0f8;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  font-variant-numeric: tabular-nums;
  grid-column: 1 / -1;
  margin-top: 0.1rem;
  overflow: hidden;
}

.relatorio-grupo-conta-tipos-cabecalho,
.relatorio-grupo-conta-tipo,
.relatorio-grupo-conta-totais {
  align-items: center;
  display: grid;
  gap: 0.35rem;
  grid-template-columns: minmax(0, 1fr) minmax(42px, 58px) minmax(42px, 58px) minmax(
      48px,
      64px
    );
  min-width: 0;
}

.relatorio-grupo-conta-tipos-cabecalho {
  background: #f8fafc;
  border-bottom: 1px solid #eef0f8;
  color: #7e8299;
  font-size: 0.7rem;
  font-weight: 800;
  padding: 0.4rem 0.5rem;
  text-transform: uppercase;
}

.relatorio-grupo-conta-tipos-cabecalho span:not(:first-child) {
  text-align: right;
}

.relatorio-grupo-conta-tipo {
  background: #ffffff;
  border-bottom: 1px solid #eef0f8;
  font-size: 0.78rem;
  grid-template-columns:
    9px minmax(0, 1fr) minmax(42px, 58px) minmax(42px, 58px)
    minmax(48px, 64px);
  padding: 0.38rem 0.5rem;
}

.relatorio-grupo-conta-tipo:last-of-type {
  border-bottom: 0;
}

.relatorio-grupo-conta-totais {
  background: #f8fafc;
  border-top: 1px solid #dfe5f2;
  color: #7e8299;
  font-size: 0.8rem;
  font-weight: 800;
  padding: 0.48rem 0.5rem;
  text-align: right;
}

.relatorio-grupo-conta-totais span:first-child {
  color: #3f4254;
  text-align: left;
  text-transform: uppercase;
}

.relatorio-grupo-conta-totais strong {
  color: #181c32;
}

.relatorio-grupo-conta-tipos-vazio {
  color: #7e8299;
  font-size: 0.78rem;
  padding: 0.55rem 0.5rem;
}

.relatorio-grupo-conta-tipo .distribuicao-marcador {
  height: 8px;
  width: 8px;
}

.relatorio-grupo-conta-tipo-nome {
  color: #3f4254;
  font-weight: 700;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.relatorio-grupo-conta-tipo span:not(.distribuicao-marcador),
.relatorio-grupo-conta-tipo strong {
  font-variant-numeric: tabular-nums;
  text-align: right;
}

.relatorio-grupo-conta-tipo
  span:not(.relatorio-grupo-conta-tipo-nome):not(.distribuicao-marcador) {
  color: #7e8299;
}

.relatorio-grupo-conta-tipo strong {
  color: #181c32;
}

@media (max-width: 575.98px) {
  .relatorio-grupo-cabecalho,
  .relatorio-grupo-conteudo {
    padding: 0.75rem;
  }

  .relatorio-grupo-totais {
    grid-template-columns: 1fr;
    min-width: 0;
  }

  .relatorio-grupo-conta-topo {
    grid-template-columns: 1fr;
  }

  .relatorio-grupo-conta-resumo {
    align-items: stretch;
    justify-content: flex-start !important;
    min-width: 0;
  }

  .relatorio-grupo-conta-info .conta-celula-badges {
    justify-content: flex-start !important;
  }

  .relatorio-grupo-conta-tipos-cabecalho,
  .relatorio-grupo-conta-totais {
    grid-template-columns: minmax(0, 1fr) repeat(3, minmax(38px, auto));
  }

  .relatorio-grupo-conta-tipo {
    font-size: 0.74rem;
    gap: 0.25rem;
    grid-template-columns: 8px minmax(0, 1fr) repeat(3, minmax(38px, auto));
    padding-left: 0.35rem;
    padding-right: 0.35rem;
  }
}

@media (max-width: 1499.98px) {
  .relatorio-grupo-conteudo {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (max-width: 1199.98px) {
  .relatorio-grupo-cabecalho {
    display: grid;
    grid-template-columns: 1fr;
  }
}

.relatorio-tabela-container {
  border: 1px solid var(--color-border-soft, #eef0f8);
  border-radius: 4px;
  max-width: 100%;
  overflow-x: hidden;
  width: 100%;
}

.relatorio-tabela {
  margin-bottom: 0;
  min-width: 0;
  width: 100%;
  table-layout: fixed;
}

.relatorio-tabela >>> th.coluna-consumo,
.relatorio-tabela >>> td.coluna-consumo {
  width: 88px;
}

.relatorio-tabela >>> th.coluna-composicao,
.relatorio-tabela >>> td.coluna-composicao {
  min-width: 0;
  width: 38%;
}

.relatorio-tabela >>> th.coluna-acoes,
.relatorio-tabela >>> td.coluna-acoes {
  width: 246px;
}

.relatorio-tabela >>> .conta-celula {
  min-width: 0;
}

.relatorio-tabela >>> .conta-celula-cliente {
  max-width: 100%;
}

.relatorio-tabela >>> .coluna-composicao .distribuicao-consumo {
  min-width: 0;
  width: 100%;
}

.relatorio-tabela >>> .coluna-composicao .distribuicao-cabecalho,
.relatorio-tabela >>> .coluna-composicao .distribuicao-item {
  gap: 0.45rem;
  grid-template-columns:
    minmax(140px, 1fr) minmax(48px, 0.28fr) minmax(48px, 0.28fr)
    minmax(58px, 0.34fr);
}

.relatorio-tabela >>> .coluna-composicao .distribuicao-label {
  white-space: normal;
}

.relatorio-tabela >>> .coluna-composicao .distribuicao-numero,
.relatorio-tabela >>> .coluna-composicao .distribuicao-total {
  white-space: nowrap;
}

.relatorio-tabela >>> .acoes-tabela {
  max-width: 246px;
}

.relatorio-tabela >>> thead th {
  background: #f8fafc;
  border-bottom-color: #eef0f8;
  color: #3f4254;
  font-size: 0.92rem;
  font-weight: 700;
  text-transform: uppercase;
  vertical-align: middle;
  white-space: normal;
}

.relatorio-tabela >>> th.coluna-consumo,
.relatorio-tabela >>> th.coluna-acoes {
  white-space: nowrap;
}

.relatorio-tabela >>> .acoes-tabela .btn-acao {
  flex: 0 0 auto;
  white-space: nowrap;
}

.relatorio-tabela >>> tbody td {
  border-top: 12px solid #f1f3f9;
  box-shadow: inset 0 1px 0 #ccd4e2;
  font-size: 0.95rem;
  padding-bottom: 0.85rem;
  padding-top: 0.85rem;
  vertical-align: top;
}

.relatorio-tabela >>> tbody tr td {
  background: #ffffff;
}

.relatorio-tabela >>> tbody tr:hover td {
  background: #fbfcff;
}

.relatorio-tabela >>> .b-table-empty-row td,
.relatorio-tabela >>> tbody tr.b-table-empty-row td {
  min-width: 100%;
  width: 100%;
}

.relatorio-tabela >>> .b-table-empty-row .relatorio-vazio-tabela,
.relatorio-tabela >>> tbody tr.b-table-empty-row .relatorio-vazio-tabela {
  align-items: center;
  justify-content: center;
  min-height: 180px;
  width: 100%;
}

.relatorio-tabela >>> .linha-sem-consumo td {
  color: #a1a5b7;
}

.relatorio-tabela >>> .linha-grupo-conta td {
  background: #f8fafc;
  border-top: 14px solid #e8edf5;
  box-shadow: inset 0 1px 0 #aeb9cc;
}

.relatorio-tabela >>> .linha-grupo-conta:hover td {
  background: #f5f8ff;
}

.relatorio-tabela >>> .linha-subconta td {
  border-top: 3px solid #ffffff;
  box-shadow: inset 0 1px 0 #e4e8f0;
}

.relatorio-tabela >>> .linha-subconta td:first-child {
  box-shadow: inset 3px 0 0 #eef0f8;
}

.conta-celula {
  display: flex;
  flex-direction: column;
  min-width: 180px;
}

.conta-celula-nome {
  color: #181c32;
  font-weight: 600;
  line-height: 1.2;
}

.conta-celula-cliente {
  color: #7e8299;
  line-height: 1.25;
  margin-top: 0.2rem;
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.conta-celula-grupo .conta-celula-nome {
  font-weight: 700;
}

.conta-celula-subconta {
  padding-left: 1rem;
  position: relative;
}

.conta-celula-subconta::before {
  background: #d7deed;
  content: "";
  height: 1px;
  left: 0;
  position: absolute;
  top: 0.75rem;
  width: 0.55rem;
}

.conta-celula-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  margin-top: 0.45rem;
}

.conta-badge {
  align-items: center;
  border: 1px solid #d7deed;
  border-radius: 4px;
  color: #3f4254;
  display: inline-flex;
  font-size: 0.8rem;
  font-weight: 700;
  gap: 0.3rem;
  line-height: 1;
  min-height: 26px;
  padding: 0.38rem 0.55rem;
  text-transform: uppercase;
  white-space: nowrap;
}

.conta-badge-ativa {
  background: #edfdf8;
  border-color: #8de2c7;
}

.conta-badge-inativa {
  background: #fff5f5;
  border-color: #f2b6bd;
}

.conta-badge-whatsapp {
  background: #eefbfa;
  border-color: #8adbd6;
}

.conta-badge-integracao {
  background: #f1f8ff;
  border-color: #a8d4ff;
  color: #1b6fbd;
  padding-right: 0.48rem;
}

.conta-badge-integracao::after {
  content: "\2197";
  font-size: 0.82rem;
  font-weight: 800;
  line-height: 1;
}

.conta-badge-integracao:hover,
.conta-badge-integracao:focus {
  color: #155a9a;
  text-decoration: none;
}

.conta-badge-sem-integracao {
  background: #f8fafc;
  border-color: #d7deed;
  color: #7e8299;
}

.conta-badge-faturamento-faturada {
  background: #edfdf8;
  border-color: #8de2c7;
  color: #0e8058;
}

.conta-badge-faturamento-grupo {
  background: #eef6ff;
  border-color: #a8d4ff;
  color: #1b6fbd;
}

.conta-badge-faturamento-parcial {
  background: #fff8dd;
  border-color: #ffe7a3;
  color: #946200;
}

.conta-badge-faturamento-pendente {
  background: #fff5f5;
  border-color: #f2b6bd;
  color: #b42335;
}

.conta-faturamento-info {
  color: #7e8299;
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1.25;
  margin-top: 0.35rem;
}

.contas-grupo-lista {
  background: #ffffff;
  border: 1px solid #dfe5f2;
  border-radius: 4px;
  margin-top: 0.8rem;
  padding: 0.65rem;
}

.contas-grupo-titulo {
  color: #7e8299;
  font-size: 0.78rem;
  font-weight: 700;
  margin-bottom: 0.45rem;
  text-transform: uppercase;
}

.contas-grupo-item {
  align-items: center;
  display: grid;
  gap: 0.45rem;
  grid-template-columns: 10px minmax(0, 1fr) auto auto;
  padding: 0.35rem 0;
}

.contas-grupo-item + .contas-grupo-item {
  border-top: 1px solid #eef0f8;
}

.contas-grupo-marcador {
  background: #d7deed;
  border-radius: 50%;
  height: 7px;
  width: 7px;
}

.contas-grupo-textos {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.contas-grupo-textos strong {
  color: #181c32;
  font-size: 0.88rem;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.contas-grupo-textos small {
  color: #7e8299;
  font-size: 0.78rem;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.valor-consumo {
  color: #3f4254;
  display: inline-block;
  font-variant-numeric: tabular-nums;
  min-width: 52px;
  text-align: right;
}

.valor-consumo-total {
  color: #181c32;
  font-weight: 700;
}

.valor-consumo-zero {
  color: #b5b5c3;
}

.valor-consumo-rodape {
  color: #181c32;
}

.distribuicao-consumo {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  min-width: 620px;
}

.distribuicao-cabecalho,
.distribuicao-item {
  display: grid;
  gap: 0.6rem;
  grid-template-columns: minmax(260px, 1fr) 72px 72px 86px;
}

.distribuicao-cabecalho {
  color: #7e8299;
  font-size: 0.8rem;
  font-weight: 700;
  padding: 0 0.5rem 0.2rem;
  text-transform: uppercase;
}

.distribuicao-cabecalho span:not(:first-child) {
  text-align: right;
}

.distribuicao-item {
  align-items: center;
  background: #ffffff;
  border: 1px solid #eef0f8;
  border-radius: 4px;
  min-height: 40px;
  overflow: hidden;
  padding: 0.45rem 0.55rem;
}

.distribuicao-item:hover {
  border-color: #d7deed;
}

.distribuicao-tipo {
  align-items: center;
  display: flex;
  gap: 0.5rem;
  min-width: 0;
}

.distribuicao-marcador {
  border-radius: 50%;
  flex: 0 0 auto;
  height: 9px;
  width: 9px;
}

.distribuicao-tipo-textos {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.distribuicao-label {
  color: #3f4254;
  font-size: 0.92rem;
  font-weight: 600;
  line-height: 1.2;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.distribuicao-tipo-textos small,
.distribuicao-total-grupo small {
  color: #7e8299;
  font-size: 0.8rem;
  line-height: 1.15;
}

.distribuicao-numero,
.distribuicao-total {
  color: #3f4254;
  font-size: 0.92rem;
  font-variant-numeric: tabular-nums;
  text-align: right;
}

.distribuicao-total-grupo {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
}

.distribuicao-total {
  color: #181c32;
  font-weight: 700;
}

.distribuicao-trilho {
  background: #eef0f8;
  border-radius: 4px;
  grid-column: 1 / -1;
  height: 5px;
  overflow: hidden;
}

.distribuicao-barra {
  border-radius: inherit;
  display: block;
  height: 100%;
  max-width: 100%;
}

.distribuicao-whatsapp .distribuicao-marcador,
.distribuicao-whatsapp .distribuicao-barra {
  background: #1bc5bd;
}

.distribuicao-sms .distribuicao-marcador,
.distribuicao-sms .distribuicao-barra {
  background: #ffa800;
}

.distribuicao-email .distribuicao-marcador,
.distribuicao-email .distribuicao-barra {
  background: #3699ff;
}

.distribuicao-processadas .distribuicao-marcador,
.distribuicao-processadas .distribuicao-barra {
  background: #8950fc;
}

.distribuicao-outro .distribuicao-marcador,
.distribuicao-outro .distribuicao-barra {
  background: #7e8299;
}

.distribuicao-whatsapp {
  border-left: 3px solid rgba(27, 197, 189, 0.85);
}

.distribuicao-sms {
  border-left: 3px solid rgba(255, 168, 0, 0.85);
}

.distribuicao-email {
  border-left: 3px solid rgba(54, 153, 255, 0.85);
}

.distribuicao-processadas {
  border-left: 3px solid rgba(137, 80, 252, 0.85);
}

.distribuicao-outro {
  border-left: 3px solid rgba(126, 130, 153, 0.85);
}

.distribuicao-total-linha {
  background: transparent;
  border: 0;
  border-radius: 0;
  border-top: 2px solid #6f7788;
  margin-top: 0.65rem;
  padding: 0.65rem 0.5rem 0.15rem;
}

.distribuicao-total-linha:hover {
  background: transparent;
}

.distribuicao-total-linha .distribuicao-marcador {
  background: #3f4254;
}

.distribuicao-item-total .distribuicao-label,
.distribuicao-item-total .distribuicao-numero,
.distribuicao-item-total .distribuicao-total {
  color: #181c32;
  font-size: 1rem;
  font-weight: 800;
}

.distribuicao-item-total .distribuicao-tipo-textos small,
.distribuicao-item-total .distribuicao-total-grupo small {
  color: #3f4254;
  font-weight: 700;
}

.distribuicao-item-total .distribuicao-trilho {
  display: none;
}

.distribuicao-item-total .distribuicao-marcador {
  border-radius: 3px;
  height: 14px;
  width: 14px;
}

.distribuicao-vazia {
  color: #a1a5b7;
  font-size: 0.88rem;
}

.relatorio-total-row th {
  background: #f3f6f9;
  border-top: 1px solid #e4e6ef;
}

.acoes-tabela {
  align-items: center;
  display: flex;
  flex-wrap: nowrap;
  gap: 0.35rem;
  justify-content: center;
  max-width: 246px;
}

.btn-acao {
  border-width: 1px;
  font-size: 0.8rem;
  font-weight: 700;
  min-height: 30px;
  padding: 0.3rem 0.55rem;
}

.btn-acao-cobranca {
  color: #0e8058;
  min-width: 36px;
}

.btn-acao-cobranca:hover,
.btn-acao-cobranca:focus {
  color: #096a48;
}

.cobranca-modal {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.cobranca-modal-topo {
  align-items: end;
  display: grid;
  gap: 1rem;
  grid-template-columns: minmax(180px, 240px) 1fr;
}

.cobranca-modal-label {
  color: #3f4254;
  font-size: 0.82rem;
  font-weight: 700;
  text-transform: uppercase;
}

.cobranca-modal-resumo {
  display: grid;
  gap: 0.6rem;
  grid-template-columns: repeat(5, minmax(105px, 1fr));
}

.cobranca-modal-resumo div {
  background: #f8fafc;
  border: 1px solid #eef0f8;
  border-radius: 4px;
  padding: 0.6rem 0.7rem;
}

.cobranca-modal-resumo span {
  color: #7e8299;
  display: block;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
}

.cobranca-modal-resumo strong {
  color: #181c32;
  display: block;
  font-size: 1rem;
  margin-top: 0.15rem;
  text-align: right;
}

.cobranca-progresso-info {
  align-items: center;
  color: #7e8299;
  display: flex;
  font-size: 0.88rem;
  justify-content: space-between;
  margin-bottom: 0.35rem;
}

.cobranca-progresso-info strong {
  color: #181c32;
}

.cobranca-progresso-trilho {
  background: #eef0f8;
  border-radius: 4px;
  height: 8px;
  overflow: hidden;
}

.cobranca-progresso-barra {
  background: #1bc5bd;
  display: block;
  height: 100%;
  transition: width 0.2s ease;
}

.cobranca-fila {
  border: 1px solid #eef0f8;
  border-radius: 4px;
  max-height: 420px;
  overflow-y: auto;
  overscroll-behavior: contain;
  scroll-behavior: smooth;
}

.cobranca-fila-item {
  background: #ffffff;
  border-left: 4px solid #d7deed;
  padding: 0.75rem;
}

.cobranca-fila-item + .cobranca-fila-item {
  border-top: 1px solid #eef0f8;
}

.cobranca-fila-item-processando {
  border-left-color: #3699ff;
  background: #fffaf4;
  box-shadow: inset 0 0 0 1px rgba(255, 121, 0, 0.18);
}

.cobranca-fila-item-concluido {
  border-left-color: #1bc5bd;
}

.cobranca-fila-item-erro {
  border-left-color: #f64e60;
}

.cobranca-fila-item-aviso {
  border-left-color: #ff7900;
}

.cobranca-fila-item-cancelado {
  border-left-color: #7e8299;
}

.cobranca-fila-principal {
  align-items: flex-start;
  display: flex;
  gap: 0.8rem;
  justify-content: space-between;
}

.cobranca-fila-principal strong,
.cobranca-fila-principal small {
  display: block;
}

.cobranca-fila-principal strong {
  color: #181c32;
}

.cobranca-fila-principal small,
.cobranca-fila-mensagem,
.cobranca-fila-detalhes {
  color: #7e8299;
  font-size: 0.85rem;
}

.cobranca-fila-mensagem {
  margin-top: 0.45rem;
  white-space: pre-line;
}

.cobranca-fila-detalhes {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 0.4rem;
}

.cobranca-status {
  border: 1px solid #d7deed;
  border-radius: 4px;
  font-size: 0.76rem;
  font-weight: 700;
  padding: 0.3rem 0.45rem;
  text-transform: uppercase;
  white-space: nowrap;
}

.cobranca-status-aguardando {
  background: #f8fafc;
  color: #7e8299;
}

.cobranca-status-processando {
  background: #eef6ff;
  border-color: #a8d4ff;
  color: #1b6fbd;
}

.cobranca-status-concluido {
  background: #edfdf8;
  border-color: #8de2c7;
  color: #0e8058;
}

.cobranca-status-erro {
  background: #fff5f5;
  border-color: #f2b6bd;
  color: #b42335;
}

.cobranca-status-aviso {
  background: #fff7f0;
  border-color: #ff7900;
  color: #482182;
}

.cobranca-status-cancelado {
  background: #f1f3f9;
  color: #7e8299;
}

.cobranca-fila-aviso-agrupamento,
.cobranca-fila-contas-agrupadas {
  background: #fff7f0;
  border: 1px solid #ffdfbf;
  border-radius: 4px;
  color: #482182;
  display: grid;
  gap: 0.18rem;
  margin-top: 0.55rem;
  padding: 0.55rem 0.65rem;
}

.cobranca-fila-contas-agrupadas {
  background: #f4eefb;
  border-color: #e8dff2;
}

.cobranca-fila-aviso-agrupamento strong,
.cobranca-fila-contas-agrupadas strong {
  color: #482182;
  font-size: 0.76rem;
  font-weight: 800;
  text-transform: uppercase;
}

.cobranca-fila-aviso-agrupamento span,
.cobranca-fila-contas-agrupadas span {
  color: #6b6178;
  font-size: 0.86rem;
  font-weight: 600;
}

.cobranca-retornos-tabela {
  border: 1px solid #e8dff2;
  border-radius: 4px;
  margin-top: 0.6rem;
  overflow-x: auto;
  overflow-y: hidden;
}

.cobranca-retornos-cabecalho,
.cobranca-retornos-linha {
  align-items: center;
  display: grid;
  gap: 0.5rem;
  grid-template-columns:
    minmax(150px, 1fr) minmax(72px, 0.55fr) minmax(78px, 0.6fr)
    minmax(78px, 0.6fr) minmax(120px, 1fr);
  min-width: 540px;
}

.cobranca-retornos-cabecalho {
  background: #f4eefb;
  color: #6b6178;
  font-size: 0.72rem;
  font-weight: 800;
  padding: 0.45rem 0.6rem;
  text-transform: uppercase;
}

.cobranca-retornos-linha {
  background: #ffffff;
  border-top: 1px solid #e8dff2;
  color: #6b6178;
  font-size: 0.82rem;
  padding: 0.5rem 0.6rem;
}

.cobranca-retornos-cabecalho span:not(:first-child),
.cobranca-retornos-linha span:not(:first-child),
.cobranca-retornos-linha strong {
  text-align: right;
}

.cobranca-retornos-linha strong {
  color: #482182;
}

.cobranca-retornos-tipo,
.cobranca-retornos-plano {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cobranca-retornos-tipo {
  color: #181c32;
  font-weight: 800;
  text-align: left !important;
}

.cobranca-retornos-tipo small {
  color: #6b6178;
  display: block;
  font-size: 0.72rem;
  font-weight: 700;
  margin-top: 0.12rem;
}

.cobranca-modal-acoes {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
  background: #ffffff;
  border-top: 1px solid var(--color-border-soft, #e8dff2);
  bottom: -1rem;
  margin: 0 -1rem -1rem;
  padding: 0.85rem 1rem 1rem;
  position: sticky;
  z-index: 2;
}

@media (max-width: 767.98px) {
  .cobranca-modal-topo,
  .cobranca-modal-resumo {
    grid-template-columns: 1fr;
  }
}

.relatorio-vazio {
  align-items: center;
  color: var(--color-text-muted, #7e8299);
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  justify-content: center;
  padding: 1.25rem;
}

.relatorio-vazio-tabela {
  min-height: 180px;
  width: 100%;
}

.relatorio-vazio strong {
  color: #3f4254;
}

.filtro-select-resumo {
  align-items: center;
  color: #3f4254;
  display: flex;
  gap: 0.35rem;
  min-height: 36px;
  min-width: 0;
  overflow: hidden;
  padding: 0 0.5rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}

.filtro-select-resumo span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.filtro-select-resumo small {
  color: #7e8299;
  flex: 0 0 auto;
  font-size: 0.82rem;
  font-weight: 600;
  line-height: 1;
}

.filtro-integracao-resumo {
  align-items: center;
  min-height: 36px;
}

.filtro-integracao-resumo small {
  color: #7e8299;
}

.filtro-contas-wrapper {
  position: relative;
}

.filtro-contas-limpar {
  align-items: center;
  background: transparent;
  border: 0;
  color: #000000;
  cursor: pointer;
  display: inline-flex;
  height: 28px;
  justify-content: center;
  line-height: 1;
  padding: 0;
  position: absolute;
  right: 2.45rem;
  top: 50%;
  transform: translateY(-50%);
  width: 28px;
  z-index: 2;
}

.filtro-contas-limpar:hover,
.filtro-contas-limpar:focus {
  color: #3699ff;
  outline: none;
}

.filtro-conta-opcao,
.filtro-integracao-opcao {
  align-items: center;
  display: flex;
  gap: 0.75rem;
  justify-content: space-between;
  min-height: 42px;
  min-width: 0;
  padding: 0.15rem 0;
  width: 100%;
}

.filtro-opcao-principal {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
  min-width: 0;
}

.filtro-opcao-nome {
  color: #181c32;
  font-size: 0.99rem;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.filtro-opcao-meta {
  color: #7e8299;
  font-size: 0.86rem;
  margin-top: 0.12rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.filtro-opcao-badge {
  align-items: center;
  background: #eef6ff;
  border: 1px solid #a8d4ff;
  border-radius: 4px;
  color: #1b6fbd;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 0.78rem;
  font-weight: 800;
  line-height: 1;
  min-height: 24px;
  padding: 0.3rem 0.45rem;
  text-transform: uppercase;
  white-space: nowrap;
}

.filtro-opcao-badge-neutro {
  background: #f8fafc;
  border-color: #d7deed;
  color: #7e8299;
}

.contas-selecionadas-painel {
  background: #ffffff;
  border: 1px solid #eef0f8;
  border-radius: 4px;
  margin-top: 0.25rem;
  padding: 0.85rem 1rem;
}

.contas-selecionadas-cabecalho {
  align-items: center;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  margin-bottom: 0.75rem;
}

.contas-selecionadas-titulo {
  color: #3f4254;
  font-size: 0.92rem;
  font-weight: 600;
}

.contas-selecionadas-subtitulo {
  color: #7e8299;
  font-size: 0.88rem;
  margin-top: 0.15rem;
}

.contas-selecionadas-lista {
  display: grid;
  gap: 0.45rem 0.75rem;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  max-height: 170px;
  overflow-y: auto;
  padding-right: 0.25rem;
}

.contas-selecionadas-item {
  align-items: center;
  background: #f8fafc;
  border: 1px solid #eef0f8;
  border-radius: 4px;
  display: flex;
  gap: 0.5rem;
  min-height: 36px;
  min-width: 0;
  padding: 0.35rem 0.35rem 0.35rem 0.65rem;
}

.contas-selecionadas-nome {
  color: #181c32;
  display: flex;
  flex: 1;
  flex-direction: column;
  font-size: 0.88rem;
  line-height: 1.2;
  min-width: 0;
  overflow: hidden;
}

.contas-selecionadas-nome strong,
.contas-selecionadas-nome small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.contas-selecionadas-nome strong {
  font-weight: 700;
}

.contas-selecionadas-nome small {
  color: #7e8299;
  font-size: 0.78rem;
  margin-top: 0.1rem;
}

.contas-selecionadas-remover {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 4px;
  color: #7e8299;
  cursor: pointer;
  display: flex;
  font-size: 1.15rem;
  height: 28px;
  justify-content: center;
  line-height: 1;
  padding: 0;
  width: 28px;
}

.contas-selecionadas-remover:hover,
.contas-selecionadas-remover:focus {
  background: #f1f3f9;
  color: #f64e60;
  outline: none;
}

.filtros-resumo {
  background: #f8fafc;
  border: 1px solid #eef0f8;
  border-radius: 4px;
  margin-top: 0.25rem;
  padding: 0.85rem 1rem;
}

.filtros-resumo-titulo {
  color: #3f4254;
  font-size: 0.92rem;
  font-weight: 600;
  margin-bottom: 0.65rem;
}

.filtros-resumo-lista {
  display: grid;
  gap: 0.6rem 1rem;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
}

.filtros-resumo-item {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.filtros-resumo-label {
  color: #7e8299;
  font-size: 0.92rem;
  font-weight: 600;
  margin-bottom: 0.1rem;
  text-transform: uppercase;
}

.filtros-resumo-valor {
  color: #181c32;
  font-size: 0.9rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.filtro-contas >>> .p-multiselect-label,
.filtro-integracao >>> .p-dropdown-label {
  align-items: center;
  color: #3f4254;
  display: flex;
  font-weight: 500;
  min-height: 36px;
  padding-bottom: 0;
  padding-top: 0;
}

.filtro-contas-com-limpar >>> .p-multiselect-label {
  padding-right: 2rem;
}

.filtro-contas >>> .p-multiselect-label-container {
  min-height: 38px;
}

.filtro-integracao >>> .p-dropdown-panel {
  box-sizing: border-box;
  max-width: 100%;
  min-width: 100%;
  width: 100%;
}

.filtro-integracao >>> .p-dropdown-items-wrapper {
  max-width: 100%;
  overflow-x: hidden;
}

.filtro-integracao >>> .p-dropdown-items {
  min-width: 0;
}

.filtro-contas >>> .p-multiselect-filter-container,
.filtro-integracao >>> .p-dropdown-filter-container {
  align-items: center;
  display: flex;
  width: 100%;
}

.filtro-contas >>> .p-multiselect-filter,
.filtro-integracao >>> .p-dropdown-filter {
  box-sizing: border-box;
  font-size: 0.98rem;
  height: 40px;
  min-height: 40px;
  padding-left: 0.75rem;
  padding-right: 2.25rem;
  width: 100%;
}

.filtro-contas >>> .p-multiselect-filter-icon,
.filtro-integracao >>> .p-dropdown-filter-icon {
  right: 0.75rem;
}

.filtro-contas >>> .p-multiselect-item,
.filtro-integracao >>> .p-dropdown-item {
  box-sizing: border-box;
  max-width: 100%;
  min-width: 0;
  padding: 0.55rem 0.75rem;
}

.card-custom {
  font-size: 1rem;
}

.card-custom >>> label,
.card-custom >>> .form-control,
.card-custom >>> .btn {
  font-size: 0.98rem;
}

.filtros-ativos-indicador {
  font-size: 0.86rem;
}

.visao-relatorio-toggle >>> .btn,
.visualizacao-agrupamento-toggle >>> .btn {
  font-size: 0.98rem;
}

.resultado-indicador-label,
.resultado-indicador-descricao,
.legenda-item {
  font-size: 1rem;
}

.resultado-indicador-valor {
  font-size: 1.65rem;
}

.relatorio-grupo-totais span,
.relatorio-grupo-contas-titulo,
.distribuicao-cabecalho,
.cobranca-modal-label,
.cobranca-modal-resumo span {
  font-size: 0.9rem;
}

.relatorio-grupo-totais strong,
.cobranca-modal-resumo strong {
  font-size: 1.12rem;
}

.relatorio-grupo-conta-info strong,
.conta-celula-nome {
  font-size: 1rem;
}

.relatorio-grupo-conta-info small,
.conta-celula-cliente,
.distribuicao-tipo-textos small,
.distribuicao-total-grupo small,
.contas-selecionadas-subtitulo,
.contas-selecionadas-nome,
.filtros-resumo-valor,
.cobranca-fila-principal small,
.cobranca-fila-mensagem,
.cobranca-fila-detalhes {
  font-size: 0.94rem;
}

.conta-badge,
.cobranca-status {
  font-size: 0.88rem;
}

.conta-badge-integracao::after {
  font-size: 0.92rem;
}

.relatorio-grupo-conta-tipo {
  font-size: 0.88rem;
}

.distribuicao-label,
.distribuicao-numero,
.distribuicao-total,
.valor-consumo {
  font-size: 1rem;
}

.distribuicao-item-total .distribuicao-label,
.distribuicao-item-total .distribuicao-numero,
.distribuicao-item-total .distribuicao-total {
  font-size: 1.08rem;
}

.relatorio-tabela >>> thead th {
  font-size: 1rem;
}

.relatorio-tabela >>> tbody td {
  font-size: 1.02rem;
}

.btn-acao {
  font-size: 0.9rem;
}

.cobranca-progresso-info {
  font-size: 0.98rem;
}

.contas-selecionadas-titulo,
.filtros-resumo-titulo,
.filtros-resumo-label {
  font-size: 1rem;
}
.card-custom {
  --color-brand-orange: #ff7900;
  --color-brand-purple: #482182;
  --color-white: #ffffff;
  --color-black: #000000;
  --color-primary: var(--color-brand-orange);
  --color-secondary: var(--color-brand-purple);
  --color-bg-primary: var(--color-white);
  --color-bg-soft: #fff7f0;
  --color-bg-purple-soft: #f4eefb;
  --color-text-primary: var(--color-brand-purple);
  --color-text-muted: #6b6178;
  --color-text-inverse: var(--color-white);
  --color-border-soft: #e8dff2;
  --color-border-brand: var(--color-brand-purple);
  --color-button-primary-bg: var(--color-brand-orange);
  --color-button-primary-text: var(--color-white);
  --color-button-secondary-bg: var(--color-brand-purple);
  --color-button-secondary-text: var(--color-white);
  --color-link: var(--color-brand-purple);
  --color-focus: var(--color-brand-orange);
  color: var(--color-text-primary);
}

.card-custom .card-header {
  border-bottom: 1px solid var(--color-border-soft);
  box-shadow: inset 0 3px 0 var(--color-white);
}

.card-custom .card-label,
.card-custom label,
.card-custom .filtros-ativos-indicador,
.card-custom .filtros-resumo-label,
.card-custom .contas-selecionadas-titulo,
.card-custom .contas-grupo-titulo,
.card-custom .relatorio-grupo-contas-titulo,
.card-custom .cobranca-modal-label {
  color: var(--color-brand-purple);
}

.card-custom .filtros-ativos-indicador {
  background: var(--color-bg-purple-soft);
  border: 1px solid var(--color-border-soft);
  border-left: 3px solid var(--color-brand-orange);
}

.card-custom >>> .btn-light-warning,
.card-custom >>> .btn-success,
.btn-gerar-cobranca,
.btn-acao-cobranca {
  background: var(--color-brand-orange);
  border-color: var(--color-brand-orange);
  color: var(--color-text-inverse);
}

.card-custom >>> .btn-light-warning:hover,
.card-custom >>> .btn-light-warning:focus,
.card-custom >>> .btn-success:hover,
.card-custom >>> .btn-success:focus,
.btn-gerar-cobranca:hover,
.btn-gerar-cobranca:focus,
.btn-acao-cobranca:hover,
.btn-acao-cobranca:focus {
  background: #e86e00;
  border-color: #e86e00;
  color: var(--color-text-inverse);
}

.card-custom >>> .btn-light-primary,
.card-custom >>> .btn-light-secondary,
.card-custom >>> .btn-acao,
.card-custom >>> .btn-light-primary:not(.active),
.card-custom >>> .btn-light-secondary:not(.active) {
  background: var(--color-bg-purple-soft);
  border-color: var(--color-border-soft);
  color: var(--color-brand-purple);
}

.card-custom >>> .btn-light-primary:hover,
.card-custom >>> .btn-light-primary:focus,
.card-custom >>> .btn-light-secondary:hover,
.card-custom >>> .btn-light-secondary:focus,
.card-custom >>> .btn-acao:hover,
.card-custom >>> .btn-acao:focus {
  background: #ece2fb;
  border-color: var(--color-brand-purple);
  color: var(--color-brand-purple);
}

.card-custom >>> .btn-light-primary.active,
.card-custom >>> .btn-light-primary:not(:disabled):not(.disabled):active,
.card-custom >>> .btn-light-secondary.active,
.card-custom >>> .btn-light-secondary:not(:disabled):not(.disabled):active,
.visao-relatorio-toggle >>> .btn.active,
.visao-relatorio-toggle >>> .btn:not(:disabled):not(.disabled):active,
.visualizacao-agrupamento-toggle >>> .btn.active,
.visualizacao-agrupamento-toggle >>> .btn:not(:disabled):not(.disabled):active {
  background: var(--color-brand-purple);
  border-color: var(--color-brand-purple);
  color: var(--color-text-inverse);
}

.card-custom >>> .btn:focus,
.card-custom >>> .form-control:focus,
.card-custom >>> .p-inputtext:focus,
.card-custom >>> .p-multiselect:not(.p-disabled).p-focus,
.card-custom >>> .p-dropdown:not(.p-disabled).p-focus {
  border-color: var(--color-focus);
  box-shadow: 0 0 0 0.18rem rgba(255, 121, 0, 0.16);
}

.card-custom >>> .form-control,
.card-custom >>> .p-inputtext,
.card-custom >>> .p-dropdown,
.card-custom >>> .p-multiselect {
  border-color: var(--color-border-soft);
  color: var(--color-brand-purple);
}

.card-custom >>> .p-dropdown-label,
.card-custom >>> .p-multiselect-label,
.card-custom >>> .p-dropdown-filter,
.card-custom >>> .p-multiselect-filter {
  color: var(--color-brand-purple);
}

.card-custom >>> .p-dropdown-panel,
.card-custom >>> .p-multiselect-panel,
.card-custom >>> .p-overlaypanel {
  border: 1px solid var(--color-border-soft);
  box-shadow: 0 18px 50px rgba(72, 33, 130, 0.12);
}

.card-custom >>> .p-dropdown-item,
.card-custom >>> .p-multiselect-item {
  color: var(--color-brand-purple);
}

.card-custom >>> .p-dropdown-item.p-highlight,
.card-custom >>> .p-multiselect-item.p-highlight {
  background: var(--color-bg-purple-soft);
  color: var(--color-brand-purple);
}

.card-custom >>> .p-dropdown-filter-container,
.card-custom >>> .p-multiselect-filter-container {
  border-bottom: 1px solid var(--color-border-soft);
}

.resultado-indicador {
  border: 1px solid var(--color-border-soft);
  border-left: 3px solid var(--color-brand-orange);
}

.resultado-indicador-valor {
  color: var(--color-brand-purple);
}

.legenda-item {
  background: #ffffff;
  border-color: var(--color-border-soft);
  color: var(--color-brand-purple);
}

.relatorio-grupo-card,
.relatorio-grupo-conta,
.contas-selecionadas-painel,
.filtros-resumo,
.relatorio-tabela-container,
.cobranca-fila,
.cobranca-modal-resumo div {
  border-color: var(--color-border-soft);
}

.relatorio-grupo-cabecalho,
.relatorio-grupo-contas,
.relatorio-grupo-conta-totais,
.relatorio-tabela >>> thead th,
.filtro-select-resumo,
.filtro-opcao-badge,
.conta-badge,
.cobranca-status,
.filtros-resumo,
.contas-selecionadas-painel {
  background-color: #ffffff00;
}

.relatorio-grupo-cabecalho {
  background: var(--color-bg-purple-soft);
  border-bottom-color: var(--color-border-soft);
}

.relatorio-grupo-contas {
  background: var(--color-bg-soft);
}

.relatorio-grupo-contas-titulo,
.relatorio-grupo-conta-info strong,
.relatorio-grupo-conta-tipo-nome,
.conta-celula-nome,
.distribuicao-label,
.distribuicao-total,
.relatorio-tabela >>> thead th,
.cobranca-fila-principal strong {
  color: var(--color-brand-purple);
}

.relatorio-grupo-totais span,
.relatorio-grupo-conta-info small,
.conta-celula-cliente,
.distribuicao-tipo-textos small,
.distribuicao-total-grupo small,
.filtros-resumo-valor,
.contas-selecionadas-subtitulo,
.cobranca-fila-principal small,
.cobranca-fila-mensagem,
.cobranca-fila-detalhes,
.resultado-indicador-descricao,
.filtros-ativos-indicador,
.legenda-item {
  color: var(--color-text-muted);
}

.conta-badge-integracao,
.filtro-opcao-badge,
.conta-badge-faturamento-grupo,
.cobranca-status-processando {
  background: #f4eefb;
  border-color: var(--color-border-soft);
  color: var(--color-brand-purple);
}

.conta-badge-ativa,
.cobranca-status-concluido,
.conta-badge-faturamento-faturada {
  background: #edfdf8;
  border-color: #8de2c7;
  color: #0e8058;
}

.conta-badge-inativa,
.cobranca-status-erro,
.conta-badge-faturamento-pendente {
  background: #fff5f5;
  border-color: #f2b6bd;
  color: #b42335;
}

.conta-badge-whatsapp,
.legenda-whatsapp::before,
.distribuicao-whatsapp .distribuicao-marcador,
.distribuicao-whatsapp .distribuicao-barra,
.cobranca-progresso-barra {
  background: #1bc5bd;
}

.legenda-sms::before,
.distribuicao-sms .distribuicao-marcador,
.distribuicao-sms .distribuicao-barra {
  background: var(--color-brand-orange);
}

.legenda-email::before,
.distribuicao-email .distribuicao-marcador,
.distribuicao-email .distribuicao-barra,
.distribuicao-processadas .distribuicao-marcador,
.distribuicao-processadas .distribuicao-barra {
  background: var(--color-brand-purple);
}

.distribuicao-total-linha {
  border-top-color: var(--color-border-brand);
}

.distribuicao-total-linha .distribuicao-marcador {
  background: var(--color-brand-purple);
}

.relatorio-tabela >>> thead th {
  background: var(--color-bg-purple-soft);
  border-bottom-color: var(--color-border-soft);
}

.relatorio-tabela >>> tbody tr:hover td {
  background: #fffaf4;
}

.relatorio-total-row th {
  background: var(--color-bg-purple-soft);
  border-top-color: var(--color-border-soft);
}

.cobranca-modal-topo,
.cobranca-modal-resumo div,
.cobranca-fila,
.contas-selecionadas-item,
.filtros-resumo-item,
.filtro-conta-opcao,
.filtro-integracao-opcao {
  border-color: var(--color-border-soft);
}

.cobranca-modal-resumo div,
.contas-selecionadas-item,
.filtros-resumo,
.contas-selecionadas-painel,
.relatorio-grupo-conta,
.resultado-indicador {
  box-shadow: 0 1px 2px rgba(72, 33, 130, 0.05);
}

.card-custom >>> .p-dropdown-item:hover,
.card-custom >>> .p-multiselect-item:hover,
.card-custom >>> .p-dropdown-item.p-highlight:hover,
.card-custom >>> .p-multiselect-item.p-highlight:hover {
  background: #fff7f0;
}

/* Revisao de botoes e cobranca - Wellon */
.cobranca-modal {
  --color-brand-orange: #ff7900;
  --color-brand-purple: #482182;
  --color-bg-purple-soft: #f4eefb;
  --color-bg-soft: #fff7f0;
  --color-border-soft: #e8dff2;
  --color-text-muted: #6b6178;
  --color-text-inverse: #ffffff;
}

.card-toolbar >>> .btn-light-warning,
.card-toolbar >>> .btn-success,
.btn-gerar-cobranca,
.acoes-tabela >>> .btn-light-success.btn-acao-cobranca,
.card-custom >>> .btn-light-success.btn-acao-cobranca,
.btn-acao-cobranca {
  background: var(--color-brand-orange, #ff7900) !important;
  border-color: var(--color-brand-orange, #ff7900) !important;
  color: var(--color-text-inverse, #ffffff) !important;
}

.card-toolbar >>> .btn-light-warning:hover,
.card-toolbar >>> .btn-light-warning:focus,
.card-toolbar >>> .btn-success:hover,
.card-toolbar >>> .btn-success:focus,
.btn-gerar-cobranca:hover,
.btn-gerar-cobranca:focus,
.acoes-tabela >>> .btn-light-success.btn-acao-cobranca:hover,
.acoes-tabela >>> .btn-light-success.btn-acao-cobranca:focus,
.card-custom >>> .btn-light-success.btn-acao-cobranca:hover,
.card-custom >>> .btn-light-success.btn-acao-cobranca:focus,
.btn-acao-cobranca:hover,
.btn-acao-cobranca:focus {
  background: #e86e00 !important;
  border-color: #e86e00 !important;
  color: var(--color-text-inverse, #ffffff) !important;
}

.acoes-tabela >>> .btn-light-primary.btn-acao,
.acoes-tabela >>> .btn-light-secondary.btn-acao,
.card-custom >>> .btn-light-primary.btn-acao,
.card-custom >>> .btn-light-secondary.btn-acao {
  background: var(--color-bg-purple-soft, #f4eefb) !important;
  border-color: var(--color-border-soft, #e8dff2) !important;
  color: var(--color-brand-purple, #482182) !important;
}

.acoes-tabela >>> .btn-light-primary.btn-acao:hover,
.acoes-tabela >>> .btn-light-primary.btn-acao:focus,
.acoes-tabela >>> .btn-light-secondary.btn-acao:hover,
.acoes-tabela >>> .btn-light-secondary.btn-acao:focus,
.card-custom >>> .btn-light-primary.btn-acao:hover,
.card-custom >>> .btn-light-primary.btn-acao:focus,
.card-custom >>> .btn-light-secondary.btn-acao:hover,
.card-custom >>> .btn-light-secondary.btn-acao:focus {
  background: #ece2fb !important;
  border-color: var(--color-brand-purple, #482182) !important;
  color: var(--color-brand-purple, #482182) !important;
}

.visao-relatorio-toggle >>> .btn,
.visualizacao-agrupamento-toggle >>> .btn {
  background: var(--color-bg-purple-soft, #f4eefb);
  border-color: var(--color-border-soft, #e8dff2);
  color: var(--color-brand-purple, #482182);
}

.visao-relatorio-toggle >>> .btn:hover,
.visualizacao-agrupamento-toggle >>> .btn:hover {
  background: #ece2fb;
  border-color: var(--color-brand-purple, #482182);
  color: var(--color-brand-purple, #482182);
}

.visao-relatorio-toggle >>> .btn.active,
.visao-relatorio-toggle >>> .btn:not(:disabled):not(.disabled):active,
.visualizacao-agrupamento-toggle >>> .btn.active,
.visualizacao-agrupamento-toggle >>> .btn:not(:disabled):not(.disabled):active {
  background: var(--color-brand-purple, #482182) !important;
  border-color: var(--color-brand-purple, #482182) !important;
  color: var(--color-text-inverse, #ffffff) !important;
}

.cobranca-modal-acoes >>> .btn-success {
  background: var(--color-brand-orange, #ff7900) !important;
  border-color: var(--color-brand-orange, #ff7900) !important;
  color: var(--color-text-inverse, #ffffff) !important;
}

.cobranca-modal-acoes >>> .btn-success:hover,
.cobranca-modal-acoes >>> .btn-success:focus {
  background: #e86e00 !important;
  border-color: #e86e00 !important;
  color: var(--color-text-inverse, #ffffff) !important;
}

.cobranca-modal-acoes >>> .btn-light-secondary {
  background: var(--color-bg-purple-soft, #f4eefb) !important;
  border-color: var(--color-border-soft, #e8dff2) !important;
  color: var(--color-brand-purple, #482182) !important;
}

.cobranca-modal-acoes >>> .btn-light-secondary:hover,
.cobranca-modal-acoes >>> .btn-light-secondary:focus {
  background: #ece2fb !important;
  border-color: var(--color-brand-purple, #482182) !important;
  color: var(--color-brand-purple, #482182) !important;
}

.cobranca-modal-acoes >>> .btn-light-danger {
  background: #fff5f5 !important;
  border-color: #f2b6bd !important;
  color: #b42335 !important;
}

.cobranca-modal-acoes >>> .btn-light-danger:hover,
.cobranca-modal-acoes >>> .btn-light-danger:focus {
  background: #ffe7e9 !important;
  border-color: #e28d98 !important;
  color: #8f1d2b !important;
}

.cobranca-progresso-barra {
  background: var(--color-brand-orange, #ff7900) !important;
}

.cobranca-fila-item-refaturamento {
  background: linear-gradient(
    90deg,
    var(--color-bg-soft, #fff7f0) 0%,
    #ffffff 42%
  );
  border-left-color: var(--color-brand-orange, #ff7900);
}

.cobranca-fila-badges {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
  margin-top: 0.5rem;
}

.cobranca-refaturamento-badge {
  background: var(--color-bg-soft, #fff7f0);
  border: 1px solid var(--color-brand-orange, #ff7900);
  border-radius: 4px;
  color: var(--color-brand-purple, #482182);
  font-size: 0.75rem;
  font-weight: 800;
  line-height: 1;
  padding: 0.35rem 0.5rem;
  text-transform: uppercase;
}

.cobranca-refaturamento-info {
  color: var(--color-text-muted, #6b6178);
  font-size: 0.82rem;
  font-weight: 600;
}

/* Filtro de contas - ordenacao visual e paleta Wellon */
.card-custom .filtro-contas-wrapper >>> .p-multiselect {
  border-color: var(--color-border-soft, #e8dff2);
}

.card-custom .filtro-contas-wrapper >>> .p-multiselect:not(.p-disabled):hover {
  border-color: var(--color-brand-purple, #482182);
}

.card-custom
  .filtro-contas-wrapper
  >>> .p-multiselect:not(.p-disabled).p-focus {
  border-color: var(--color-brand-orange, #ff7900);
  box-shadow: 0 0 0 0.18rem rgba(255, 121, 0, 0.16);
}

.card-custom .filtro-contas >>> .p-multiselect-label,
.card-custom .filtro-select-resumo {
  color: var(--color-brand-purple, #482182);
  font-weight: 700;
}

.card-custom .filtro-contas-limpar {
  color: var(--color-brand-purple, #482182);
}

.card-custom .filtro-contas-limpar:hover,
.card-custom .filtro-contas-limpar:focus {
  background: var(--color-bg-soft, #fff7f0);
  color: var(--color-brand-orange, #ff7900);
}

.card-custom .contas-selecionadas-painel {
  background: var(--color-bg-purple-soft, #f4eefb);
  border-color: var(--color-border-soft, #e8dff2);
}

.card-custom .contas-selecionadas-item {
  background: var(--color-white, #ffffff);
  border-color: var(--color-border-soft, #e8dff2);
  box-shadow: inset 3px 0 0 var(--color-brand-orange, #ff7900);
}

.card-custom .contas-selecionadas-nome strong {
  color: var(--color-brand-purple, #482182);
}

.card-custom .contas-selecionadas-remover {
  color: var(--color-brand-purple, #482182);
}

.card-custom .contas-selecionadas-remover:hover,
.card-custom .contas-selecionadas-remover:focus {
  background: var(--color-bg-soft, #fff7f0);
  color: var(--color-brand-orange, #ff7900);
}

/* Botoes - revisao final Wellon */
.card-custom .card-toolbar >>> .btn,
.acoes-tabela >>> .btn-acao,
.cobranca-modal-acoes >>> .btn {
  border-radius: 4px;
  font-weight: 700;
  letter-spacing: 0;
}

.card-custom .card-toolbar >>> .btn-light-warning,
.card-custom .card-toolbar >>> .btn-success,
.card-custom >>> .btn-gerar-cobranca,
.btn-gerar-cobranca,
.cobranca-modal-acoes >>> .btn-success {
  background: var(--color-brand-orange, #ff7900) !important;
  border-color: var(--color-brand-orange, #ff7900) !important;
  color: var(--color-text-inverse, #ffffff) !important;
}

.card-custom .card-toolbar >>> .btn-light-warning:hover,
.card-custom .card-toolbar >>> .btn-light-warning:focus,
.card-custom .card-toolbar >>> .btn-success:hover,
.card-custom .card-toolbar >>> .btn-success:focus,
.card-custom >>> .btn-gerar-cobranca:hover,
.card-custom >>> .btn-gerar-cobranca:focus,
.btn-gerar-cobranca:hover,
.btn-gerar-cobranca:focus,
.cobranca-modal-acoes >>> .btn-success:hover,
.cobranca-modal-acoes >>> .btn-success:focus {
  background: #e86e00 !important;
  border-color: #e86e00 !important;
  color: var(--color-text-inverse, #ffffff) !important;
}

.card-custom .card-toolbar >>> .btn-light-primary,
.acoes-tabela >>> .btn-light-primary.btn-acao,
.acoes-tabela >>> .btn-light-secondary.btn-acao,
.card-custom >>> .btn-light-primary.btn-acao,
.card-custom >>> .btn-light-secondary.btn-acao,
.cobranca-modal-acoes >>> .btn-light-secondary {
  background: var(--color-bg-purple-soft, #f4eefb) !important;
  border-color: var(--color-border-soft, #e8dff2) !important;
  color: var(--color-brand-purple, #482182) !important;
}

.card-custom .card-toolbar >>> .btn-light-primary:hover,
.card-custom .card-toolbar >>> .btn-light-primary:focus,
.acoes-tabela >>> .btn-light-primary.btn-acao:hover,
.acoes-tabela >>> .btn-light-primary.btn-acao:focus,
.acoes-tabela >>> .btn-light-secondary.btn-acao:hover,
.acoes-tabela >>> .btn-light-secondary.btn-acao:focus,
.card-custom >>> .btn-light-primary.btn-acao:hover,
.card-custom >>> .btn-light-primary.btn-acao:focus,
.card-custom >>> .btn-light-secondary.btn-acao:hover,
.card-custom >>> .btn-light-secondary.btn-acao:focus,
.cobranca-modal-acoes >>> .btn-light-secondary:hover,
.cobranca-modal-acoes >>> .btn-light-secondary:focus {
  background: #ece2fb !important;
  border-color: var(--color-brand-purple, #482182) !important;
  color: var(--color-brand-purple, #482182) !important;
}

.visao-relatorio-toggle >>> .btn,
.visualizacao-agrupamento-toggle >>> .btn {
  background: var(--color-bg-purple-soft, #f4eefb) !important;
  border-color: var(--color-border-soft, #e8dff2) !important;
  color: var(--color-brand-purple, #482182) !important;
  font-weight: 700;
}

.visao-relatorio-toggle >>> .btn:hover,
.visualizacao-agrupamento-toggle >>> .btn:hover {
  background: #ece2fb !important;
  border-color: var(--color-brand-purple, #482182) !important;
  color: var(--color-brand-purple, #482182) !important;
}

.visao-relatorio-toggle >>> .btn.active,
.visao-relatorio-toggle >>> .btn:not(:disabled):not(.disabled):active,
.visualizacao-agrupamento-toggle >>> .btn.active,
.visualizacao-agrupamento-toggle >>> .btn:not(:disabled):not(.disabled):active {
  background: var(--color-brand-purple, #482182) !important;
  border-color: var(--color-brand-purple, #482182) !important;
  color: var(--color-text-inverse, #ffffff) !important;
}

.cobranca-modal-acoes >>> .btn-light-danger {
  background: #fff5f5 !important;
  border-color: #f2b6bd !important;
  color: #b42335 !important;
}

.cobranca-modal-acoes >>> .btn-light-danger:hover,
.cobranca-modal-acoes >>> .btn-light-danger:focus {
  background: #ffe7e9 !important;
  border-color: #e28d98 !important;
  color: #8f1d2b !important;
}

.acoes-tabela >>> .btn-light-success.btn-acao-cobranca-pendente,
.card-custom >>> .btn-light-success.btn-acao-cobranca-pendente,
.btn-acao-cobranca-pendente {
  background: var(--color-brand-orange, #ff7900) !important;
  border-color: var(--color-brand-orange, #ff7900) !important;
  color: var(--color-text-inverse, #ffffff) !important;
}

.acoes-tabela >>> .btn-light-success.btn-acao-cobranca-pendente:hover,
.acoes-tabela >>> .btn-light-success.btn-acao-cobranca-pendente:focus,
.card-custom >>> .btn-light-success.btn-acao-cobranca-pendente:hover,
.card-custom >>> .btn-light-success.btn-acao-cobranca-pendente:focus,
.btn-acao-cobranca-pendente:hover,
.btn-acao-cobranca-pendente:focus {
  background: #e86e00 !important;
  border-color: #e86e00 !important;
  color: var(--color-text-inverse, #ffffff) !important;
}

.acoes-tabela >>> .btn-light-success.btn-acao-cobranca-faturada,
.card-custom >>> .btn-light-success.btn-acao-cobranca-faturada,
.btn-acao-cobranca-faturada {
  background: var(--color-brand-purple, #482182) !important;
  border-color: var(--color-brand-purple, #482182) !important;
  color: var(--color-text-inverse, #ffffff) !important;
}

.acoes-tabela >>> .btn-light-success.btn-acao-cobranca-faturada:hover,
.acoes-tabela >>> .btn-light-success.btn-acao-cobranca-faturada:focus,
.card-custom >>> .btn-light-success.btn-acao-cobranca-faturada:hover,
.card-custom >>> .btn-light-success.btn-acao-cobranca-faturada:focus,
.btn-acao-cobranca-faturada:hover,
.btn-acao-cobranca-faturada:focus {
  background: #35165f !important;
  border-color: #35165f !important;
  color: var(--color-text-inverse, #ffffff) !important;
}

.card-custom .card-toolbar .btn-light-primary,
.card-custom .card-toolbar >>> .btn-light-primary {
  background: var(--color-bg-purple-soft, #f4eefb) !important;
  border-color: var(--color-border-soft, #e8dff2) !important;
  color: var(--color-brand-purple, #482182) !important;
}

.card-custom .card-toolbar .btn-light-primary i,
.card-custom .card-toolbar >>> .btn-light-primary i {
  color: var(--color-brand-purple, #482182) !important;
}

.card-custom .card-toolbar .btn-light-primary:hover,
.card-custom .card-toolbar .btn-light-primary:focus,
.card-custom .card-toolbar >>> .btn-light-primary:hover,
.card-custom .card-toolbar >>> .btn-light-primary:focus {
  background: #ece2fb !important;
  border-color: var(--color-brand-purple, #482182) !important;
  color: var(--color-brand-purple, #482182) !important;
}

.card-custom .card-toolbar .btn-light-primary:hover i,
.card-custom .card-toolbar .btn-light-primary:focus i,
.card-custom .card-toolbar >>> .btn-light-primary:hover i,
.card-custom .card-toolbar >>> .btn-light-primary:focus i {
  color: var(--color-brand-purple, #482182) !important;
}

.card-custom .filtro-contas-limpar {
  /* background: var(--color-bg-purple-soft, #f4eefb) !important; */
  /* border: 1px solid var(--color-border-soft, #e8dff2) !important; */
  border-radius: 4px;
  color: var(--color-brand-purple, #482182) !important;
}

.card-custom .filtro-contas-limpar i {
  color: var(--color-brand-purple, #482182) !important;
}

.card-custom .filtro-contas-limpar:hover,
.card-custom .filtro-contas-limpar:focus {
  background: var(--color-bg-soft, #fff7f0) !important;
  border-color: var(--color-brand-orange, #ff7900) !important;
  color: var(--color-brand-orange, #ff7900) !important;
  outline: none;
}

.card-custom .filtro-contas-limpar:hover i,
.card-custom .filtro-contas-limpar:focus i {
  color: var(--color-brand-orange, #ff7900) !important;
}

.card-custom .contas-selecionadas-cabecalho >>> .btn-light-primary,
.card-custom .contas-selecionadas-cabecalho .btn-light-primary {
  background: var(--color-bg-purple-soft, #f4eefb) !important;
  border-color: var(--color-border-soft, #e8dff2) !important;
  color: var(--color-brand-purple, #482182) !important;
  font-weight: 700;
}

.card-custom .contas-selecionadas-cabecalho >>> .btn-light-primary:hover,
.card-custom .contas-selecionadas-cabecalho >>> .btn-light-primary:focus,
.card-custom .contas-selecionadas-cabecalho .btn-light-primary:hover,
.card-custom .contas-selecionadas-cabecalho .btn-light-primary:focus {
  background: var(--color-bg-soft, #fff7f0) !important;
  border-color: var(--color-brand-orange, #ff7900) !important;
  color: var(--color-brand-orange, #ff7900) !important;
}

.card-custom .filtro-integracao >>> .p-dropdown-clear-icon {
  color: var(--color-brand-purple, #482182) !important;
  font-size: 0.85rem;
  margin-top: -0.42rem;
  right: 2.45rem;
}

.card-custom .filtro-integracao >>> .p-dropdown-clear-icon:hover,
.card-custom .filtro-integracao >>> .p-dropdown-clear-icon:focus {
  color: var(--color-brand-orange, #ff7900) !important;
}

.card-custom .filtro-integracao >>> .p-dropdown-label {
  padding-right: 4.25rem;
}

.relatorio-switch {
  align-items: center;
  background: var(--color-bg-purple-soft, #f4eefb);
  border: 1px solid var(--color-border-soft, #e8dff2);
  border-radius: 999px;
  display: inline-flex;
  gap: 0.2rem;
  padding: 0.2rem;
}

.relatorio-switch-opcao {
  background: transparent;
  border: 0;
  border-radius: 999px;
  color: var(--color-brand-purple, #482182);
  cursor: pointer;
  font-size: 0.86rem;
  font-weight: 800;
  line-height: 1;
  min-height: 32px;
  min-width: 94px;
  padding: 0.45rem 0.8rem;
  transition: background-color 0.15s ease, color 0.15s ease,
    box-shadow 0.15s ease;
}

.relatorio-switch-opcao:hover {
  background: #ece2fb;
  color: var(--color-brand-purple, #482182);
}

.relatorio-switch-opcao:focus {
  outline: none;
}

.relatorio-switch-opcao:focus-visible {
  box-shadow: 0 0 0 0.16rem rgba(255, 121, 0, 0.22);
}

.relatorio-switch-opcao.active {
  background: var(--color-brand-purple, #482182);
  box-shadow: 0 2px 6px rgba(72, 33, 130, 0.18);
  color: var(--color-text-inverse, #ffffff);
}

.relatorio-switch-opcao.active:hover {
  background: #35165f;
  color: var(--color-text-inverse, #ffffff);
}

.relatorio-switch-opcao.active:focus {
  background: var(--color-brand-purple, #482182);
  color: var(--color-text-inverse, #ffffff);
}

.relatorio-switch-opcao.active:focus-visible {
  box-shadow: 0 2px 6px rgba(72, 33, 130, 0.18),
    0 0 0 0.16rem rgba(255, 121, 0, 0.22);
}

.card-custom .conta-badge-integracao {
  background: var(--color-white, #ffffff) !important;
  border-color: var(--color-brand-purple, #482182) !important;
  color: var(--color-brand-purple, #482182) !important;
}

.card-custom .conta-badge-integracao:hover,
.card-custom .conta-badge-integracao:focus {
  background: var(--color-bg-soft, #fff7f0) !important;
  border-color: var(--color-brand-orange, #ff7900) !important;
  color: var(--color-brand-orange, #ff7900) !important;
  text-decoration: none;
}

.relatorio-grupo-cabecalho .conta-badge-integracao {
  box-shadow: 0 1px 2px rgba(72, 33, 130, 0.08);
}

.card-custom .cobranca-fila-item-aviso {
  border-left-color: var(--color-brand-orange, #ff7900) !important;
}

.card-custom .cobranca-status-aviso {
  background: var(--color-bg-soft, #fff7f0) !important;
  border-color: var(--color-brand-orange, #ff7900) !important;
  color: var(--color-brand-purple, #482182) !important;
}

/* Select de contas - paleta Wellon sem alterar overlay */
.card-custom .filtro-contas-wrapper >>> .p-multiselect {
  border-color: var(--color-border-soft, #e8dff2);
  color: var(--color-brand-purple, #482182);
}

.card-custom .filtro-contas-wrapper >>> .p-multiselect:not(.p-disabled):hover {
  border-color: var(--color-brand-purple, #482182);
}

.btn-acao-cobrancas {
  background: var(--color-black, #000000) !important;
  border-color: var(--color-black, #000000) !important;
  color: var(--color-white, #ffffff);
}

.btn-acao-cobrancas:hover,
.btn-acao-cobrancas:focus {
  background: var(--color-brand-orange, #ff7900) !important;
  border-color: var(--color-brand-orange, #ff7900) !important;
  color: var(--color-white, #ffffff) !important;
}

.relatorio-grupo-acao.btn-acao-cobrancas {
  background: var(--color-brand-orange, #ff7900) !important;
  border-color: var(--color-brand-orange, #ff7900) !important;
  color: var(--color-white, #ffffff) !important;
}

.relatorio-grupo-acao.btn-acao-cobrancas:hover,
.relatorio-grupo-acao.btn-acao-cobrancas:focus {
  background: #e86e00 !important;
  border-color: #e86e00 !important;
  color: var(--color-white, #ffffff) !important;
}

.relatorio-grupo-acao-principal.btn-acao-cobrancas {
  background: var(--color-brand-purple, #482182) !important;
  border-color: var(--color-brand-purple, #482182) !important;
  color: var(--color-white, #ffffff) !important;
}

.relatorio-grupo-acao-principal.btn-acao-cobrancas:hover,
.relatorio-grupo-acao-principal.btn-acao-cobrancas:focus {
  background: var(--color-brand-orange, #ff7900) !important;
  border-color: var(--color-brand-orange, #ff7900) !important;
  color: var(--color-white, #ffffff) !important;
}

.relatorio-grupo-acao {
  align-self: center;
  flex: 0 0 auto;
  justify-content: center;
  min-height: 28px;
  min-width: 82px;
  padding: 0.25rem 0.45rem;
  white-space: nowrap;
}

.faturamento-detalhe-modal {
  display: grid;
  gap: 1rem;
}

.faturamento-detalhe-topo {
  display: grid;
  gap: 0.75rem;
  grid-template-columns: minmax(180px, 1.1fr) minmax(180px, 1fr) minmax(
      160px,
      0.8fr
    );
}

.faturamento-detalhe-topo > div,
.faturamento-detalhe-card,
.faturamento-detalhe-observacoes {
  background: var(--color-white, #ffffff);
  border: 1px solid var(--color-border-soft, #e8dff2);
  border-radius: 6px;
}

.faturamento-detalhe-topo > div {
  box-shadow: inset 3px 0 0 var(--color-brand-orange, #ff7900);
  display: grid;
  gap: 0.25rem;
  padding: 0.85rem 1rem;
}

.faturamento-detalhe-topo span,
.faturamento-detalhe-card-topo span,
.faturamento-detalhe-itens-cabecalho,
.faturamento-detalhe-observacoes strong {
  color: var(--color-text-muted, #6b6178);
  font-size: 0.86rem;
  font-weight: 800;
  text-transform: uppercase;
}

.faturamento-detalhe-topo strong,
.faturamento-detalhe-vendas {
  align-items: flex-start;
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.faturamento-detalhe-venda-link {
  align-items: center;
  background: var(--color-black, #000000);
  border: 1px solid var(--color-black, #000000);
  border-radius: 4px;
  color: var(--color-white, #ffffff) !important;
  display: inline-flex;
  font-size: 0.86rem;
  font-weight: 800;
  gap: 0.28rem;
  line-height: 1;
  padding: 0.42rem 0.55rem;
  text-decoration: none;
  white-space: nowrap;
}

.faturamento-detalhe-venda-icone {
  color: var(--color-white, #ffffff) !important;
  display: inline-block;
  font-size: 0.9rem;
  font-weight: 900;
  line-height: 1;
  transform: translateY(-1px);
}

.faturamento-detalhe-venda-link:hover,
.faturamento-detalhe-venda-link:focus {
  background: var(--color-brand-orange, #ff7900);
  border-color: var(--color-brand-orange, #ff7900);
  color: var(--color-white, #ffffff);
  text-decoration: none;
}

.faturamento-detalhe-card-topo strong {
  color: var(--color-brand-purple, #482182);
  font-size: 1.08rem;
  font-weight: 900;
}

.faturamento-detalhe-topo small {
  color: var(--color-text-muted, #6b6178);
  font-weight: 600;
  font-size: 0.9rem;
}

.faturamento-detalhe-observacoes {
  background: var(--color-bg-soft, #fff7f0);
  display: grid;
  gap: 0.35rem;
  padding: 0.85rem 1rem;
}

.faturamento-detalhe-observacoes span {
  color: var(--color-brand-purple, #482182);
  font-size: 0.94rem;
  font-weight: 700;
}

.faturamento-detalhe-lista {
  display: grid;
  gap: 0.85rem;
}

.faturamento-detalhe-card {
  overflow: hidden;
}

.faturamento-detalhe-card-topo {
  background: var(--color-bg-purple-soft, #f4eefb);
  border-bottom: 1px solid var(--color-border-soft, #e8dff2);
  display: grid;
  gap: 0.75rem;
  grid-template-columns:
    minmax(210px, 1.15fr) minmax(110px, 0.5fr) minmax(300px, 1.75fr)
    minmax(90px, 0.5fr);
  padding: 0.85rem 1rem;
}

.faturamento-detalhe-card-topo > div:nth-child(3) strong {
  overflow: visible;
  text-overflow: initial;
  white-space: normal;
}

.faturamento-detalhe-card-topo > div {
  display: grid;
  gap: 0.2rem;
  min-width: 0;
}

.faturamento-detalhe-card-topo strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.faturamento-detalhe-itens {
  padding: 0.75rem 1rem 1rem;
}

.faturamento-detalhe-itens-cabecalho,
.faturamento-detalhe-item {
  align-items: center;
  display: grid;
  gap: 0.65rem;
  grid-template-columns: minmax(220px, 1fr) 88px 88px 88px 104px;
}

.faturamento-detalhe-itens-cabecalho span:not(:first-child),
.faturamento-detalhe-item span:not(:first-child),
.faturamento-detalhe-item strong {
  text-align: right;
}

.faturamento-detalhe-item {
  border-top: 1px solid var(--color-border-soft, #e8dff2);
  font-size: 0.96rem;
  color: var(--color-brand-purple, #482182);
  font-weight: 700;
  padding: 0.55rem 0;
}

.faturamento-detalhe-item:first-of-type {
  border-top: 0;
}

.faturamento-detalhe-item small {
  font-size: 0.88rem;
  color: var(--color-text-muted, #6b6178);
  display: block;
  font-weight: 700;
}

.faturamento-detalhe-item strong {
  color: var(--color-brand-orange, #ff7900);
  font-weight: 900;
}

@media (max-width: 991.98px) {
  .faturamento-detalhe-topo,
  .faturamento-detalhe-card-topo {
    grid-template-columns: 1fr;
  }

  .faturamento-detalhe-itens {
    overflow-x: auto;
  }

  .faturamento-detalhe-itens-cabecalho,
  .faturamento-detalhe-item {
    min-width: 620px;
  }
}
.relatorio-carregando {
  align-items: center;
  background: var(--color-bg-soft, #fff7f0);
  border: 1px solid var(--color-border-soft, #e8dff2);
  border-radius: 6px;
  color: var(--color-text-primary, #482182);
  display: flex;
  font-weight: 700;
  justify-content: center;
  margin-bottom: 1rem;
  padding: 0.85rem 1rem;
}

.relatorio-paginacao {
  align-items: center;
  border: 1px solid var(--color-border-soft, #e8dff2);
  border-radius: 6px;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  margin-top: 1rem;
  padding: 0.85rem 1rem;
}

.relatorio-paginacao-resumo {
  color: var(--color-text-muted, #6b6178);
  font-size: 0.95rem;
}

.relatorio-paginacao-resumo strong {
  color: var(--color-text-primary, #482182);
}

.relatorio-paginacao-controles {
  align-items: center;
  display: flex;
  gap: 0.75rem;
}

.relatorio-paginacao-select {
  min-width: 150px;
}

.relatorio-paginacao >>> .pagination {
  margin-bottom: 0;
}

@media (max-width: 767.98px) {
  .relatorio-paginacao,
  .relatorio-paginacao-controles {
    align-items: stretch;
    flex-direction: column;
  }
}
</style>

<style>
.relatorio-consolidado-contas-overlay .p-multiselect-items-wrapper {
  height: 320px !important;
  max-height: 320px !important;
  overflow-y: auto;
}

.relatorio-consolidado-contas-overlay .p-multiselect-items {
  min-height: 100%;
}

.relatorio-consolidado-contas-overlay .p-multiselect-empty-message {
  align-items: center;
  color: #6b6178;
  display: flex;
  justify-content: center;
  min-height: 260px;
  text-align: center;
}

.relatorio-consolidado-contas-overlay,
.relatorio-consolidado-contas-overlay .p-multiselect-items,
.relatorio-consolidado-contas-overlay .p-multiselect-list {
  background: #ffffff;
}

.relatorio-consolidado-contas-overlay .p-dropdown-item,
.relatorio-consolidado-contas-overlay .p-multiselect-item {
  background: #ffffff;
  color: #482182;
}

.relatorio-consolidado-contas-overlay .p-dropdown-item:hover,
.relatorio-consolidado-contas-overlay .p-multiselect-item:hover {
  background: #fff7f0;
  color: #482182;
}

.relatorio-consolidado-contas-overlay .p-dropdown-item.p-highlight,
.relatorio-consolidado-contas-overlay .p-multiselect-item.p-highlight {
  background: #482182;
  color: #ffffff;
}

.relatorio-consolidado-contas-overlay
  .p-multiselect-item.p-highlight
  .filtro-opcao-nome,
.relatorio-consolidado-contas-overlay
  .p-multiselect-item.p-highlight
  .filtro-opcao-meta {
  color: #ffffff;
}

.relatorio-consolidado-contas-overlay
  .p-multiselect-item.p-highlight
  .filtro-opcao-badge {
  background: #ffffff;
  border-color: #ffffff;
  color: #482182;
}

.relatorio-consolidado-contas-overlay .p-checkbox .p-checkbox-box.p-highlight {
  background: #ff7900;
  border-color: #ff7900;
}
</style>
